import { OptionMenuApps } from './../../../../enums/shared/menu-home.enum';
import { MenuAppsModel } from './../../../../entities/shared/MenuApps';
import { IMenuData } from './../../../../interfaces/shared/menu-home.interface';
import { altaEntidades_domains } from './../../../../entities/shared/AltaEntidades';
import { BuscadorService } from './../../../../services/shared/buscador/buscador.service';
import { Persona } from "src/app/entities/shared/Persona";
import { HandleProfileService } from './../../../../services/shared/handle-profile/handle-profile.service';
import { Component, ElementRef, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewChildren, QueryList, AfterViewInit, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from "@angular/forms";

import { ConfirmationDialogService } from "src/app/services/shared/confirmation-dialog/confirmation-dialog.service";
import { FuenteDinamicaService } from "src/app/services/shared/fuente-dinamica/fuente-dinamica.service";
import { NotificationService } from "src/app/services/shared/notification/notification.service";
import { EntityDinamica } from "src/app/entities/shared/EntityDinamica";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";

import { ThemePalette } from "@angular/material/core";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { SharedService } from "src/app/services/shared/shared.service";

import { HistorialHelper } from "src/app/helpers/historial-utils";
import { EstructuraDinamicaField } from "src/app/entities/shared/EstructuraDinamicaField";

import { environment } from 'src/environments/environment';
import { LogService } from 'src/app/services/shared/logs/log.service';
import { Router } from '@angular/router';
import { noEditableNewObservationVisible } from 'src/app/entities/shared/NoEditableNewObservation';
import { vipUyContributionAutoFields } from 'src/app/entities/shared/VipUyContributionAutoFields';
import { DatesTimesService } from 'src/app/utils/dates-times/dates-times.service';
import { IFieldFieldsSourceDIS, IFieldsSourceDIS } from "src/app/interfaces/shared/fields-source-dis.interface"
import { FieldsSourceDIS } from 'src/app/entities/shared/FieldsMockSourceDIS';
import { futureDateValidator, numberDecimalFormatValidator, pastDateValidator, rutValidator } from 'src/app/validators/';
import {
  operationDateNotAfterDefaultValidator,
  noDecimalSeparatorValidator,
  saldoDeudorMinByCurrencyValidator,
  maxAgainstFieldValidator
} from 'src/app/validators/uyCreditDefaultValidators';
import { ModalSize } from "@signal/component-library/efx-modal";
import { PersistenciaService } from 'src/app/services/shared/persistencia-movimientos/persistencia.service';
import { DatePipe } from '@angular/common';
import { ContributionService } from 'src/app/services/shared/contribution/contribution.service';
import { NotificationAlertService } from 'src/app/components/shared/notifications-alert/service/notifications-alert.service';
import { AuditService } from 'src/app/services/shared/audit/audit.service';

@Component({
  selector: "app-fuente-dinamica-detail",
  templateUrl: "./fuente-dinamica-detail.component.html",
  styleUrls: ["./fuente-dinamica-detail.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FuenteDinamicaDetailComponent implements OnInit, OnChanges, AfterViewInit {
  //   questions: Observable<QuestionBase<any>[]>;
  //   payLoad = '';
  componentName = "FuenteDinamicaDetailComponent";
  form: FormGroup;
  @Input() counterExternalRDS: number = 0;
  @Input() selectedFuenteDinamica: EntityDinamica;
  @Input() editionMode: boolean;
  @Input() isAdding: boolean = false;

  currentMatchKey: string = "";
  selectedFuenteDinamicaBackUp: EntityDinamica = null;

  @Input() dataviewsSchema: any[];
  @Input() FUENTE_PASCAL_CASE: string;
  @Input() SUB_DOMAIN_JO: string;
  typeServiceMenu: any;
  @Output() showList = new EventEmitter();
  @Output() showReloadList = new EventEmitter<{
    subDomainJO: string;
    currentMatchKeyOld: string;
    currentMatchKeyNew: string;
    currentCountry: string;
  }>();
  @Output() emitIsEditing: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onIsAdding: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() disabledButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() setSubTitle: EventEmitter<string> = new EventEmitter<string>();

  fuenteDinamicaForm: FormGroup;
  isEditing: boolean = false;
  fuenteDinamicaData: EntityDinamica; // currentRow
  currentPersona: Persona;

  tituloPagina = "";
  columnsVisible = [];

  tipoOperacionList = [];
  vinculacionList = [];
  estadoList = [];
  esPublicaList = [];

  sectionArray: any = [];
  tempItem: any;
  sectionOrder = [];
  attributesOrder: any;

  relationIntegranteIUP: string;

  listSectionAvailableSource = [];

  now: Date = new Date();
  minDate = { year: 1900, month: 1, day: 1 };
  maxDate = {
    year: this.now.getFullYear(),
    month: this.now.getMonth() + 1,
    day: this.now.getDate(),
  };
  time = "12:20";

  // default service tkl
  service = "tkl";

  ///// tablet ////////
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator | any = [];
  @ViewChild(MatSort, { static: true }) sort: MatSort | any = [];
  // Instancias de efx-dropdown (via #gfdDropdown) para poder poblar sus pills en edición.
  @ViewChildren('gfdDropdown') efxDropdowns: QueryList<any>;
  // array //
  tempArray: any = {};
  mapEditors: Record<string, FormArray> = {};

  pageSize = 10;
  color: ThemePalette = "primary";

  domain: string;
  dataviews: any;

  historyList: { id: string; description: string }[] | null = null;
  historyListModal: any = null;
  history: any[] | null = null;
  toggleHistory: boolean;
  noEditableView: boolean;

  /** Campos que difieren entre el registro del historial seleccionado y el original */
  historyDiffFields: Set<string> = new Set();

  struct: EstructuraDinamicaField[];
  // structBackup: EstructuraDinamicaField[];

  tempValidators: any = {
    name: "",
    type: "",
    value: "",
  }

  tempValidatorsValues: any = {
    min: '',
    max: '',
    maxlength: '',
    minlength: ''
  }

  tempModal: any = {
    name: "",
    msg: "",
    value: "",
    state: false
  }
  //// periodos ////
  periods: boolean = false;
  periodsType: string = "";
  periodsSection: string = "";
  tempPeriods: any = {};
  isSoftDelete: boolean = false;

  /// template ///
  @ViewChild('template', { static: false }) template: ElementRef<HTMLInputElement>;
  tempTemplate: any = {};
  templateInput: any = {}
  @Input() buttonAdd: boolean = false;

  //// seguimiento-reqid observacion anterior ////
  boCambioMatchkey: boolean = false;

  //// periods manuals /////

  //// periodos ////
  arrayPeriodosHist = [];
  ultimoPeriodoInformado;
  originalHistoric;
  itemSituaciones: any = {
    mes: null,
    anio: null,
    situacion: null,
    fecha: null,
    mesnum: null,
    editable: null,
    situacion_new: null,
    codigo: null,
    matchKey: null,
    rowKey: null,
    iup: null,
    periodo: null
  };
  tempPeriodsTypeSituacion: string = '';
  tempPeriodsTitleMethod: string = '';
  changePeriods: any;
  changeSituation: any;
  tempPeriodsVariant: any = {}
  tempSelect = [];
  currentObject: any;
  iCanRegistros: number = 0;

  // Expose String constructor for template use
  String = String;

  successDIS: boolean = false;

  // Modal Variables
  bodyModal: string;
  modalSize = ModalSize;
  showModal: boolean = false;
  tituloModal: string;

  get currentCountry() {
    return this.localStorageService?.getRegionSeleccionada?.getCode();
  }

  get getIsVip() {
    return this.localStorageService.getIsVip;
  }

  private fuenteDinamicaService: FuenteDinamicaService;
  private confirmationDialogService: ConfirmationDialogService;
  private dialog: MatDialog;
  private notificationService: NotificationService;
  private sharedService: SharedService;
  private fb: FormBuilder;
  private handleProfileService: HandleProfileService
  private logService: LogService;
  private datesTimesService: DatesTimesService;
  private buscadorService: BuscadorService;
  private persistenciaService: PersistenciaService;
  private cdr: ChangeDetectorRef;
  private auditService: AuditService;

  stateBlock: boolean = false;

  atributosFuenteModif = [];

  constructor(
    injector: Injector,
    private localStorageService: LocalStorageService,
    private historialHelper: HistorialHelper,
    private router: Router,
    private datePipe: DatePipe,
    private contributionService: ContributionService,
    private notificationAlertService: NotificationAlertService
  ) {
    this.fuenteDinamicaService = injector.get<FuenteDinamicaService>(FuenteDinamicaService);
    this.logService = injector.get<LogService>(LogService);
    this.datesTimesService = injector.get<DatesTimesService>(DatesTimesService);
    this.confirmationDialogService = injector.get<ConfirmationDialogService>(ConfirmationDialogService);
    this.dialog = injector.get<MatDialog>(MatDialog);
    this.notificationService = injector.get<NotificationService>(NotificationService);
    this.sharedService = injector.get<SharedService>(SharedService);
    this.fb = injector.get<FormBuilder>(FormBuilder);
    this.handleProfileService = injector.get<HandleProfileService>(HandleProfileService);
    this.buscadorService = injector.get<BuscadorService>(BuscadorService);
    this.persistenciaService = injector.get<PersistenciaService>(PersistenciaService);
    this.cdr = injector.get<ChangeDetectorRef>(ChangeDetectorRef);
    this.auditService = injector.get<AuditService>(AuditService);

    this.localStorageService.selectDirty = {};
    this.localStorageService.dateBackup = {};

    this.sharedService.getdataBloqueo().subscribe({
      next: data => {
        this.stateBlock = data;

      }
    })
  }

  setDataTemplateDIS() {
    if (this.templateInput.changeTexto && this.templateInput.changeTexto !== '') {
      const { relation, changeTexto } = this.templateInput;
      const formValue = this.form.value;
      const newValue = `${changeTexto} ${formValue[relation]}`;
      this.form.get(relation)?.setValue(newValue);
    }
  }

  setDataTemplate(event) {
    const value = event;
    const keys = Object.keys(value);

    let text = this.templateInput.text;
    const newTexto = keys.reduce((textoActual, key) => {
      return textoActual.replace(`{{${key}}}`, value[key])
    }, text);

    this.templateInput.changeTexto = newTexto;
  }

  changeTemplate(event) {
    const name = event.source?.id || event.target?.name;
    const value = event.value ?? event.target?.value;

    const { template } = this.tempTemplate[name];

    const t1 = template.models.find(x => x.model === value);

    let html = "";
    if (t1) {
      let text = t1.text;
      const text2 = t1.fields.reduce((textoActual, palabra) => {
        return textoActual.replace(`{{${palabra.name}}}`, `<span class="py-3 w-300px" id="${palabra.name}"></span>`)
      }, text);

      let form = {}

      t1.fields.forEach(x => {
        form[x.name] = ['', Validators.required]
      })

      this.templateInput = {
        html: text2,
        form,
        text,
        relation: template.relation,
        fields: t1.fields,
        changeTexto: '',
      }
    }

  }

  selectModelTemplate(value, i) {
    const { template } = value;
    const option = value.template.models.map(x => { return x.model });
    this.tempTemplate[value.name] = {
      template,
      option,
      index: i
    }
  }

  validator(valid: any, inputType?: string) {

    const validadores: any[] = [];
    if (!Array.isArray(valid)) {
      return validadores;
    }

    valid.forEach((element) => {
      const validatorType = String(element?.type ?? '').trim().toLowerCase();

      switch (validatorType) {
        case "required":
          validadores.push(Validators.required);
          break;
        case "minlength":
          validadores.push(Validators.minLength(element.value));
          break;
        case "maxlength":
          validadores.push(Validators.maxLength(element.value));
          break;
        case "min":
          validadores.push(Validators.min(element.value));
          break;
        case "max":
          const regex = /[.,]/;
          if (regex.test(String(element.value))) {
            validadores.push(numberDecimalFormatValidator(element.value));
          }
          validadores.push(Validators.max(element.value));
          break;
        case "email":
          validadores.push(Validators.email);
          break;
        case "pattern":
          validadores.push(Validators.pattern(this.normalizeValidatorPattern(element.value)));
          break;
        case "rutvalidator":
          validadores.push(rutValidator());
          break;

        case "pastdate":
          if (String(inputType || '').toLowerCase() === 'date') {
            validadores.push(pastDateValidator());
          }
          break;

        case "futuredate":
          if (String(inputType || '').toLowerCase() === 'date') {
            validadores.push(futureDateValidator());
          }
          break;
        default:
          break;
      }
    });
    return validadores;
  }

  // Validador personalizado para campos string mandatorios que no permiten "NULL"
  notNullStringValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === "NULL") {
        return { nullString: { value: control.value } };
      }
      return null;
    };
  }

  initFormGroupFormArray(data): FormGroup {

    return new FormGroup(data);
  }

  initDataViews() {
    this.dataviews = this.dataviewsSchema ? [...this.dataviewsSchema] : [];
  }

  callHistory(toggle: boolean) {
    if (toggle) {
      const subDomain = this.SUB_DOMAIN_JO;
      const country = this.currentCountry.toUpperCase();
      let matchK, matchKey;

      if (subDomain === "DELINQUENCY_BOLAB" || subDomain === "BOLAB_RDS") {
        const sep = this.localStorageService.dataEstructuraDinamicaHeader?.separator || '.';
        matchK = this.fuenteDinamicaData.matchKey.split(sep);
        matchKey = `${matchK[0]}${sep}${matchK[1]}`;
      } else {
        matchK = this.fuenteDinamicaData.matchKey;
        matchKey = matchK.endsWith('.') ? matchK.slice(0, -1) : matchK;
      }

      this.toggleHistory = toggle;

      if (this.history === null)
        this.sharedService
          .getHistory(country, this.domain, subDomain, matchKey)
          .subscribe({
            next: (historial) => {
              if (historial["payload"][subDomain]) {
                this.historyList = this.historialHelper.dropDownList(
                  historial["payload"][subDomain], subDomain
                );

                this.history = historial["payload"][subDomain];
                this.historyListModal = this.historialHelper.generateListHistModal(this.history, this.historyList);

              } else {
                this.toggleHistory = false;
                this.errorUpdate("history");
              }
            },
            error: (e) => {
              this.toggleHistory = false;
              this.errorUpdate(e);
            },
          });
    } else {
      this.selectedFuenteDinamica = this.selectedFuenteDinamicaBackUp;
      this.fuenteDinamicaData = this.selectedFuenteDinamicaBackUp;
      // Limpiar campos marcados como diferentes del historial
      this.historyDiffFields.clear();
      this.ngOnInit();
    }
  }

  updateFuenteHistorySelected(timestamp: any) {
    // Verificar que el historial esté cargado
    if (!this.history || this.history.length === 0) {
      console.warn('[FD-Detail] El historial no está cargado:', this.history);
      return;
    }

    // Buscar el registro del historial:
    // - Primero busca por data.header (selección desde modal)
    // - Si no encuentra, busca por journalingTimestamp (selección desde dropdown)
    let historyRecord = this.history.find(
      (data) => String(data['data.header']) === String(timestamp)
    );

    if (!historyRecord) {
      historyRecord = this.history.find(
        (data) => String(data.journalingTimestamp) === String(timestamp)
      );
    }

    if (historyRecord) {
      // Deserializar el registro completo del historial (incluye data.header, matchKey, etc.)
      const deserializedRecord = new EntityDinamica().deserialize(historyRecord);
      this.selectedFuenteDinamica = deserializedRecord;
      this.fuenteDinamicaData = new EntityDinamica().deserialize(historyRecord);

      // Calcular campos que difieren del registro original
      this.calculateHistoryDiffFields(historyRecord);

      // Log para debugging - verificar que data.header se preserva
      console.log('[FD-Detail] Registro del historial seleccionado:', {
        'data.header': (deserializedRecord as any)['data.header'],
        'matchKey': deserializedRecord.matchKey,
        'journalingTimestamp': deserializedRecord.journalingTimestamp,
        'camposDiferentes': Array.from(this.historyDiffFields)
      });

      this.ngOnInit();
    } else {
      console.warn('[FD-Detail] No se encontró registro del historial con timestamp:', timestamp);
    }
  }

  /**
   * Calcula qué campos del registro del historial difieren del registro original (backup).
   * Marca esos campos en historyDiffFields para que se muestren con estilo visual diferente.
   */
  calculateHistoryDiffFields(historyRecord: any): void {
    this.historyDiffFields.clear();

    if (!this.selectedFuenteDinamicaBackUp || !historyRecord) {
      return;
    }

    // Recorrer la estructura para comparar solo campos relevantes
    const fieldsToCompare = this.struct || this.columnsVisible || [];

    for (const field of fieldsToCompare) {
      const fieldName = field.name;
      if (!fieldName) continue;

      // Excluir campos internos
      if (['matchKey', 'rowKey', 'keying', 'data.header', 'journalingTimestamp',
        'recordAction', 'dfContributionName'].includes(fieldName)) {
        continue;
      }

      const historyValue = historyRecord[fieldName];
      const originalValue = (this.selectedFuenteDinamicaBackUp as any)[fieldName];

      // Comparar valores normalizados a string
      if (String(historyValue ?? '') !== String(originalValue ?? '')) {
        this.historyDiffFields.add(fieldName);
      }
    }

    console.log('[FD-Detail] Campos que difieren del original:', Array.from(this.historyDiffFields));
  }

  /**
   * Verifica si un campo difiere del registro original (para aplicar estilo visual).
   */
  isFieldFromHistory(fieldName: string): boolean {
    return this.historyDiffFields.has(fieldName);
  }

  onRemoveItemFormArray(i: number, index: number) {
    const value: any = this.getValueIndexArray(index);
    const arrayForm = this.form.get(value.name) as FormArray;
    this.form.markAsDirty();
    arrayForm.removeAt(i);
    arrayForm.markAsDirty();
  }

  fillStructObject(keyO: any, value: any, struct: any) {

    for (let i = 0; i < keyO.length; i++) {
      let temValue =
        value[i] === null || value[i] === undefined ? "" : value[i];
      struct[keyO[i]] = new FormControl(temValue);
    }

  }

  addDataFormArray(key: string, dataArray: Array<any>, values?: any) {


    let arrayForm = this.form.get(key) as FormArray;

    if (!arrayForm) {
      arrayForm = new FormArray([]);
      this.form.addControl(key, arrayForm);
    } else {
      arrayForm.clear();
    }

    let typeData: any = typeof dataArray[0];
    let keyO: any = null;
    let columns: any = null;
    let dataSource = new MatTableDataSource();
    let dataArrayTemp;
    let displayedColumns = [];



    if (typeData === "object") {
      keyO = Object.keys(dataArray[0]);
      dataArrayTemp = [];
      dataArray.forEach((element) => {
        let struct = {};
        let value = Object.values(element);
        this.fillStructObject(keyO, value, struct);

        arrayForm.push(this.initFormGroupFormArray(struct));
      });
      columns = [];
      let noVisible = [];
      values.forEach((element) => {
        if (Boolean(element.visible)) {
          columns.push(element);
          displayedColumns.push(element.name);
        } else {
          noVisible.push(element.name);
        }
      });
      if (noVisible.length > 0) {
        dataArray.forEach((x) => {
          let value = { ...x };
          noVisible.forEach((element) => {
            Reflect.deleteProperty(value, element);
          });
          dataArrayTemp.push(value);
        });
      } else {
        dataArrayTemp = dataArray;
      }
    } else {
      dataArrayTemp = dataArray;
      dataArray.forEach((element) => {

        arrayForm.push(new FormControl(element));
      });
    }

    dataSource.data = dataArrayTemp;

    this.tempArray[key] = {
      name: key,
      type: typeData,
      key: keyO,
      columns,
      index: null,
      dataSource,
      displayedColumns,
    };


  }

  getValueIndexArray(index: number) {
    const array = Object.values(this.tempArray);
    return array.find((x: any) => x.index === index);
  }

  addControlArrayObject(index: number) {
    const value: any = this.getValueIndexArray(index);
    const arrayForm = this.form.get(value.name) as FormArray;

    if (value.type === "object") {
      let struct = {};
      value.key.forEach((element) => {
        struct[element] = new FormControl("");
      });
      arrayForm.push(this.initFormGroupFormArray(struct));
    } else {
      arrayForm.push(new FormControl(""));
    }
  }

  getControl(key: string, form: any): any {
    return form.get(key);
  }

  addIndexItemArray(key: string, index: number) {

    if (!this.tempArray[key]) {
      this.tempArray[key] = {};
    }

    this.tempArray[key].index = index;
  }

  initStructDinamy() {

    this.mapEditors = {};


    this.localStorageService.setMatchkeySelected = this.fuenteDinamicaData?.matchKey;


    const { periods, periodsType, periodsSection } = this.localStorageService.getDataSourceSelected;
    this.typeServiceMenu = this.localStorageService.getRegionSeleccionada?.getService();
    this.periods = periods;
    this.periodsType = periodsType;

    this.struct = JSON.parse(JSON.stringify(this.localStorageService.getEstructuraDinamicaField));
    this.struct.forEach((field: EstructuraDinamicaField) => {
      field.inputType = this.resolveInputType(field);
    });

    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      const dataviewConfig = this.localStorageService.getDataview;
      if (dataviewConfig && Array.isArray(dataviewConfig)) {
        this.struct.forEach((fieldInStruct: EstructuraDinamicaField) => {
          const correspondingDataviewField = dataviewConfig.find(
            (dvField: any) => dvField.fieldName === fieldInStruct.name
          );
          if (correspondingDataviewField) {
            if (typeof correspondingDataviewField.isNullable === 'boolean') {
              fieldInStruct.nullable = correspondingDataviewField.isNullable;
            }
          }
        });
      }
    }

    if (this.periods && this.periodsType !== 'situation') {
      this.initPeriods();
    }

    if (this.periods && this.periodsType === 'situation') {
      const data: any = this.fuenteDinamicaData;
      this.tempPeriodsVariant["data"] = data;
      const type = data.tipo;
      this.initStructPeriodsSituation(type, data, false);
    }

    ///// genero las secciones ////
    let structs: any = {
      matchKey: this.fuenteDinamicaData.matchKey,
      rowKey: this.fuenteDinamicaData.rowKey,
    }; //todo: revisar condicion de abajo
    this.listSectionAvailableSource.length > 0 &&
      this.listSectionAvailableSource.shift();
    this.listSectionAvailableSource.push(this.SUB_DOMAIN_JO);

    const { cantEdit, visibleSections } = this.completeElements(structs);

    this.sectionArray = visibleSections;

    // Ordenar campos dentro de cada sección por el atributo 'order'
    this.sortFieldsByOrder();

    const header = this.localStorageService.dataEstructuraDinamicaHeader;
    const { section } = header;
    let sections = [];

    if (section && section.length > 0) {
      const orden = section.sort((a, b) => a.orden - b.orden);
      sections = orden.map(sec => sec.name);
    } else {
      sections = [...new Set(this.struct.map((x) => x.section))].filter(
        (y) => y !== null
      );
    }

    this.sectionOrder = sections;
    this.attributesOrder = this.sectionArray; // Usar sectionArray ya ordenado

    this.form = this.fb.group(structs);

    this.struct.forEach((element) => {
      if (element.msgModal) {
        if (element.msgModal !== null || element.msgModal !== undefined) {
          this.tempModal = {
            name: element.name,
            msg: element.msgModal,
            value: this.fuenteDinamicaData[element.name],
            state: false
          }
        }
      }
      if (element.type === "array" && element.subFields && element.subFields.length > 0) {
        if (this.fuenteDinamicaData[element.name] !== null) {
          if (this.fuenteDinamicaData[element.name].length === 0) {
            let value = [];
            let temp = {};
            element.subFields.forEach((element) => {
              temp[element.name] = "";
            });
            value.push(temp);
            if (element.editable || element.visible) {
              this.addDataFormArray(
                element.name,
                value,
                element.subFields
              );
            }
          } else {
            if (element.editable || element.visible) {
              this.addDataFormArray(
                element.name,
                this.fuenteDinamicaData[element.name],
                element.subFields
              );
            }
          }
        }
      }
    });

    this.applyUyCreditDefaultValidations();
  }

  /**
   * Validaciones cruzadas específicas de CONTRIBUTION.PER.UY_CREDIT.CREDIT_DEFAULT y
   * CONTRIBUTION.EMP.UY_CREDIT.CREDIT_DEFAULT (UY, fuente CREDIT_DEFAULT, persona o empresa).
   * Solo deshabilitan el guardado (vía form.invalid) y muestran el mensaje configurado en
   * el JSON de la fuente (defaultPerson.json / defaultEmpresa.json) debajo del campo; nunca
   * modifican el valor ingresado por el usuario.
   */
  private applyUyCreditDefaultValidations(): void {
    const country = (this.currentCountry || '').toUpperCase();
    // No depender de this.domain: en el flujo de alta VIP no siempre queda seteado con 'UY_CREDIT'
    // (se llena solo cuando getDataFuenteDinamicaList corrió con ese dominioSubDominioGKL).
    // Mismo gate ya usado y probado en submitDIS() para este mismo caso (VIP + país + SUB_DOMAIN_JO).
    const isUyCreditDefault = this.localStorageService.getIsVip && country === 'UY' && this.SUB_DOMAIN_JO === 'CREDIT_DEFAULT';

    if (!isUyCreditDefault || !this.form) {
      return;
    }

    // 2) Fecha de operación <= Fecha de incumplimiento
    const fechaOperacion = this.form.get('fecha_operacion');
    const fechaIncumplimiento = this.form.get('fecha_incumplimiento');
    if (fechaOperacion && fechaIncumplimiento) {
      fechaOperacion.addValidators(operationDateNotAfterDefaultValidator(fechaIncumplimiento));
      fechaIncumplimiento.valueChanges.subscribe(() => fechaOperacion.updateValueAndValidity({ emitEvent: false }));
      fechaOperacion.updateValueAndValidity({ emitEvent: false });
    }

    // 5) Monto solicitado y Saldo deudor: sin centésimos (sin comas ni puntos)
    const montoSolicitado = this.form.get('monto_solicitado');
    const saldoDeudor = this.form.get('saldo_deudor');
    const monedaIncumplimiento = this.form.get('moneda_incumplimiento');

    if (montoSolicitado) {
      montoSolicitado.addValidators(noDecimalSeparatorValidator());
      montoSolicitado.updateValueAndValidity({ emitEvent: false });
    }

    if (saldoDeudor) {
      saldoDeudor.addValidators(noDecimalSeparatorValidator());

      // 4) Saldo deudor: mínimo según moneda de incumplimiento
      if (monedaIncumplimiento) {
        saldoDeudor.addValidators(saldoDeudorMinByCurrencyValidator(monedaIncumplimiento));
        monedaIncumplimiento.valueChanges.subscribe(() => saldoDeudor.updateValueAndValidity({ emitEvent: false }));
      }

      // 5) Saldo deudor no debe ser mayor que Monto solicitado (si este último es numérico)
      if (montoSolicitado) {
        saldoDeudor.addValidators(maxAgainstFieldValidator(montoSolicitado));
        montoSolicitado.valueChanges.subscribe(() => saldoDeudor.updateValueAndValidity({ emitEvent: false }));
      }

      saldoDeudor.updateValueAndValidity({ emitEvent: false });
    }
  }

  completeElements(structs: any) {
    let cantEdit = 0;
    let visibleSections = {};
    this.columnsVisible = [];
    this.struct.forEach((element) => {
      if (element.visible) {
        element = this.nuevaObsDatos(element);
        this.columnsVisible.push({ ...element });
        if (visibleSections[element.section] === undefined && element.section !== null) {
          visibleSections[element.section] = [];
        }
        if (element.section !== null) {
          visibleSections[element.section].push(element.name);
        }

        if (element.editable) {
          let validators = [];
          if (element.inputType === 'date' && element.pattern === "YYYYMM") {
            this.initValueDateYearMonth(element.name);
          }

          if (element.type === "array") {
            structs[element.name] = new FormArray([]);
          } else {
            this.addElementValidators(element, validators, structs);
            cantEdit++;
          }
        }
      } else {
        element = this.nuevaObsNoVisibles(element);
      }
    });

    if (this.isAdding) {
      this.selectedFuenteDinamica.matchKey = this.localStorageService.getDataSourceSelected.matchkey || "";
      this.fuenteDinamicaData.matchKey = this.localStorageService.getDataSourceSelected.matchkey || "";
    }
    return { cantEdit, visibleSections };
  }


  private sortFieldsByOrder(): void {
    Object.keys(this.sectionArray).forEach((sectionName) => {
      const fieldNames = this.sectionArray[sectionName] as string[];


      const fieldsWithOrder = fieldNames.map((fieldName) => {
        const structField = this.struct.find((f) => f.name === fieldName);
        const order = structField?.order;
        return {
          name: fieldName,
          order: order === null || order === undefined ? Number.MAX_VALUE : Number(order),
        };
      });


      fieldsWithOrder.sort((a, b) => {
        const orderA = Number(a.order);
        const orderB = Number(b.order);
        return orderA - orderB;
      });

      this.sectionArray[sectionName] = fieldsWithOrder.map((f) => f.name);
    });
  }

  nuevaObsNoVisibles(element: EstructuraDinamicaField) { // TODO: debería añadir el dato de estos campos de forma dinámica, no manual
    if (this.isAdding) {
      const valueNoVisibles = ['iup', 'denominacion', 'entityKey'];
      const variablesCedulas = ['documento', 'rut', 'cedula'];
      // Solo aplicar lógica de persona seleccionada si NO es RDS (RDS no tiene búsqueda de persona previa)
      const isRds = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS;
      if (valueNoVisibles.includes(element?.name) && !isRds) {
        this.selectedFuenteDinamica[element.name] = this.localStorageService.getPersonaSelected[element.name];
        this.fuenteDinamicaData[element.name] = this.localStorageService.getPersonaSelected[element.name];
      } else if (variablesCedulas.includes(element?.name) && !isRds) {
        this.selectedFuenteDinamica[element?.name] = this.localStorageService.getPersonaSelected?.dniDoc || null;
      }
    }

    const country = this.currentCountry.toUpperCase();

    if (this.isAdding && this.localStorageService.getIsVip && country === 'UY') {
      this.autoCompleteContribution(element, country);
    }
    return element;
  }

  nuevaObsDatos(element: EstructuraDinamicaField) {
    const country = this.currentCountry.toUpperCase();
    const isVipUyContribution = this.localStorageService.getIsVip && country === 'UY';

    if (!!this.isAdding) {
      if (element?.section?.toUpperCase() === 'OPERACIONES') {
        this.selectedFuenteDinamica[element.name] = this.returnValueDISDataview(this.selectedFuenteDinamica, element);
        this.fuenteDinamicaData[element.name] = this.returnValueDISDataview(this.selectedFuenteDinamica, element);
      } else {
        if (this.localStorageService.esAltaEntidades) {
          const buscadorSelect = this.localStorageService.getBuscadorSelect;
          const subDomain = buscadorSelect?.subDomain;
          const domain = buscadorSelect?.domain;
          const documentVar: string = altaEntidades_domains.find(dominio => dominio.subDomain === subDomain && dominio.domain === domain)?.documentVar;
          element.editable = documentVar !== element.name;
        } else if (noEditableNewObservationVisible.includes(element?.name)) {
          // Al dejar comentado esta linea se toma siempre el valor seteado en la configuracion para ver si el campo es editable o no
          // element.editable = false;
          const variablesCedulas = ['documento', 'rut', 'cedula'];
          // Solo asignar valor de persona seleccionada si NO es RDS (RDS no tiene búsqueda de persona previa)
          const isRds = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS;
          if (variablesCedulas.includes(element?.name) && !isRds) {
            this.selectedFuenteDinamica[element?.name] = this.localStorageService.getPersonaSelected?.dniDoc || null;
          }
        } else if (isVipUyContribution && vipUyContributionAutoFields.includes(element?.name)) {
          // Campos auto-completados para incumplimientos UY VIP (persona y empresa):
          // respeta el editable que venga del configurador, no se fuerza.
        } else {
          element.editable = true;
        }
      }
    }

    if (this.isAdding && isVipUyContribution) {
      this.autoCompleteContribution(element, country);
    }
    return element;
  }

  addElementValidators(element: any, validators: any[], structs: any) {

    if (this.SUB_DOMAIN_JO === "RELACIONES") {
      // TODO: dinamizar esto
      if (element.name === "integrante_iup") {
        this.relationIntegranteIUP = this.fuenteDinamicaData[element.name];
      }
    }
    if (element.nullable === false || (element.validators && element.validators.length > 0)) {
      let valids = (element.validators && element.validators.length > 0) ? element.validators : [];

      if (element.nullable === false && !valids.some(valid => valid.type === "required")) {
        valids.push({
          "msg": "Error valor requerido",
          "type": "required",
          "value": null
        });
      }
      validators = this.validator(valids, element.inputType);

      // Si el campo es mandatorio (nullable=false) y es de tipo string, agregar validador para "NULL"
      if (element.nullable === false && element.type === "string") {
        validators.push(this.notNullStringValidator());
      }
      //validators = element.nullable === false ? [Validators.required] : this.validator(element.validators);
    }

    const getPersonaSelected = this.localStorageService.getPersonaSelected;

    let initialValue = this.fuenteDinamicaData[element.name];
    if (element.isMultiSelect && !Array.isArray(initialValue)) {
      // El valor persistido de un multiselect es un string con los códigos unidos por coma
      // (ej. "A,B,C"). Se separa para que el efx-dropdown vuelva a marcar todas las opciones.
      if (initialValue === null || initialValue === undefined || initialValue === '') {
        initialValue = [];
      } else {
        initialValue = String(initialValue).split(',').map(v => v.trim()).filter(v => v !== '');
      }
    }
    structs[element.name] = [initialValue, validators];
    return validators;
  }

  avaibleSource(item) {
    return this.listSectionAvailableSource.includes(item);
  }

  // pone titulo de la fuente a la vista
  fillEstructuraDinamicaHeader() {
    const { title } = this.localStorageService.dataEstructuraDinamicaHeader;
    this.tituloPagina = title;
    let arrayDominio =
      this.fuenteDinamicaService.dominioSubDominioDISGKL.split("/");
    this.domain = arrayDominio[0];

  }

  // DEPRECATED , esto no se ocupa !!!!
  fillEstructuraDinamicaFields() {

  }

  getItemData(item_name: string) {
    return this.columnsVisible.find((item) => item.name === item_name);
  }

  getTempValidatorsValues(validators: Array<any> | undefined) {
    const tempValidatorsValues = {
      min: '',
      max: '',
      maxlength: '',
      minlength: ''
    };

    if (validators && validators.length > 0) {
      validators.forEach((validator) => {
        const { type, value } = validator;

        if (type === 'min') {
          tempValidatorsValues.min = value;
        } else if (type === 'max') {
          tempValidatorsValues.max = value;
        } else if (type === 'maxlength') {
          tempValidatorsValues.maxlength = value;
        } else if (type === 'minlength') {
          tempValidatorsValues.minlength = value;
        } else if (type === 'dateMin') {
          const today = this.datesTimesService.getCurrentDate();
          tempValidatorsValues.min = today;
        } else if (type === 'dateMax') {
          const today = this.datesTimesService.getCurrentDate();
          tempValidatorsValues.max = today;
        }
      });
    }

    return tempValidatorsValues;
  }

  getItem(item_name) {
    this.tempItem = this.columnsVisible.find((item) => item.name === item_name);

    // Resetear siempre para evitar arrastre de validadores entre campos
    this.tempValidatorsValues = {
      min: '',
      max: '',
      maxlength: '',
      minlength: ''
    }

    const validators = this.tempItem?.validators;
    if (validators && validators.length > 0) {
      this.setTempValidatorsConditionals(validators);
    }
  }

  // Metodo que valida si la fuente es editable o solo modo vista
  editableOrViewPage(): boolean {
    let editable: number = 0;
    this.columnsVisible.forEach((campo) => {
      if (campo.editable) {
        editable++;
      }
    });
    return editable === 0;
  }

  activeSaveSofDeleted() {
    const permission = this.localStorageService.configInit['F_DIS_A'];
    //const validRole: boolean = environment.DATA_PERMISSION_PRIVATE.dm.dis.includes(this.localStorageService.getPermissionCountry.roles);
    const validRole: boolean = this.sharedService.parseRolesArray(permission).includes(this.localStorageService.getPermissionCountry.roles);

    if (this.isSoftDelete && validRole) {
      this.onEdit();
    }
  }

  ngOnInit(): void {

    this.isSoftDelete = this.selectedFuenteDinamica.recordAction === "SOFT_DELETE";

    this.fillEstructuraDinamicaHeader();
    this.fillEstructuraDinamicaFields();

    // this create arraySection and columnsVisible
    this.initStructDinamy();

    // get from backend subdomain dataview and create fill this.dataviews object
    this.initDataViews();

    this.getVinculacionList(); // objetos demos de para conocer comportamiento, no se ocupan
    this.getEsPublicaList(); // objetos demos de para conocer comportamiento, no se ocupan

    this.noEditableView = this.editableOrViewPage();

    // set selectedFuenteDinamicaBackUp when its null
    if (this.selectedFuenteDinamicaBackUp === null) {
      this.selectedFuenteDinamicaBackUp = this.selectedFuenteDinamica;
      this.localStorageService.setDataFuenteBackup = this.selectedFuenteDinamicaBackUp;
    }


    // Valida si la observacion es un seguimiento-reqid para guardar
    this.activeSaveSofDeleted();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.fuenteDinamicaData = JSON.parse(
      JSON.stringify(this.selectedFuenteDinamica)
    );

    if (this.localStorageService.getIsExternoRDS) {
      this.ngOnInit();
    }
  }

  ngAfterViewInit(): void {
    this.refreshMultiSelectPills();
    // Al re-renderizar los dropdowns (entrar a edición, cambiar de sección) repoblar pills.
    this.efxDropdowns?.changes?.subscribe(() => {
      queueMicrotask(() => this.refreshMultiSelectPills());
    });
  }

  // efx-dropdown solo arma selectedItems (fuente de los pills) al hacer click en un item,
  // no en la carga. Al entrar a edición los pills no aparecen hasta tocar el dropdown.
  // Se reconstruye selectedItems desde option.selected (que ya sincronizamos) para que
  // los pills se vean apenas se abre la edición, sin emitir cambios ni marcar dirty.
  refreshMultiSelectPills(): void {
    if (!this.efxDropdowns) {
      return;
    }
    let touched = false;
    this.efxDropdowns.forEach((dd: any) => {
      if (!dd?.isMultiSelect || !Array.isArray(dd.options)) {
        return;
      }
      // Clonar las opciones seleccionadas con la descripción truncada SOLO para los pills.
      // La lista del dropdown usa dd.options (texto completo), así no se ve afectada.
      dd.selectedItems = dd.options
        .filter((option: any) => option.selected)
        .map((option: any) => ({ ...option, description: this.truncatePillText(option.description) }));
      touched = true;
    });
    if (touched) {
      this.cdr.detectChanges();
    }
  }

  // Corta el texto del pill para que el botón del multiselect quede ordenado y no se
  // desborde. La lista completa del dropdown conserva el texto sin recortar.
  private truncatePillText(text: any, max = 22): string {
    const s = String(text ?? '');
    return s.length > max ? s.slice(0, max - 1).trimEnd() + '…' : s;
  }

  getSectionOrder(item) {
    return { order: this.sectionOrder.indexOf(item) };
  }

  getAttributeOrder(section, item) {
    if (item == "adh_matriz_desc" || item == "file_name") {
      // TODO: hacer esto dinámico en STRUCT o MENU
      return {
        order: this.attributesOrder[section].indexOf(item),
        "grid-column": "span 2",
      };
    }
    if (this.isEditing) {
      return {
        order: this.attributesOrder[section].indexOf(item),
        "justify-content": "start",
      };
    }
    return {
      order: this.attributesOrder[section].indexOf(item),
      "justify-content": "space-between",
    };

  }

  // objetos demos de para conocer comportamiento, no se ocupan
  getVinculacionList() {
    this.vinculacionList = this.fuenteDinamicaService.getVinculacionList();
  }

  getEsPublicaList() {
    this.esPublicaList = this.fuenteDinamicaService.getEsPublicaList();
  }

  // le da al texto del select el formato "CODE: DESCRIPCION"
  showCodeDescInSelect(code: string, description: string) {
    const condition = ['true', 'false', '', true, false];
    let response = '';
    if (condition.includes(code)) {
      response = description; // Antes usaba this.reducirTexto(description)
    } else {
      response = (code === description) ? code : code + ': ' + description; // Antes usaba this.reducirTexto(description)
    }
    return response;
  }

  confirmationDialog(elementChange: any[], atributosFuente: any[]) {
    // verificar actualizacion a un atributo Matchkey
    let deleteMatchkey: any = "";
    let seguimientoReqid: any;
    this.boCambioMatchkey = false;
    //se agrega esto para datos null en matchkey del header
    if (this.localStorageService.dataEstructuraDinamicaHeader.matchKey != null) {
      deleteMatchkey = this.localStorageService.dataEstructuraDinamicaHeader.matchKey
    }
    //validacion de campos para delete
    const sep = this.localStorageService.dataEstructuraDinamicaHeader?.separator || '.';
    deleteMatchkey = deleteMatchkey.split(sep);
    if (deleteMatchkey != "") {
      atributosFuente.forEach(element => {
        seguimientoReqid = deleteMatchkey.find(busca => busca === element);
        if (seguimientoReqid != undefined) {
          this.boCambioMatchkey = true;
        }
      });
    }

    const tituloModal = this.isAdding || this.isSoftDelete ? "Nuevo registro" : "Modificación";
    const bodyModal = this.isSoftDelete ?
      "¿Desea volver a generar este registro?" :
      "¿Desea confirmar los cambios realizados en " + elementChange.join(", ") + "?"

    this.confirmationDialogService
      .confirmActionWithComment(tituloModal, bodyModal)
      .then((confirmed) => {
        if (confirmed) {
          if (!this.isAdding) {
            if (this.boCambioMatchkey) {
              this.confirmationDialogService
                .confirmDeleteObservacionAnterior()
                .then((result) => {
                  if (result === true) {
                    // Usuario eligió "Borrar"
                    // Con 1 solo registro, usamos deleteFuenteDinamicaSource con criteria partial
                    const dataToDelete = [{
                      matchKey: this.selectedFuenteDinamica['matchKey']
                    }];

                    this.fuenteDinamicaService
                      .deleteFuenteDinamicaSource(
                        this.domain + "/" + this.SUB_DOMAIN_JO,
                        dataToDelete,
                        this.currentCountry
                      )
                      .subscribe((_data) => {
                        this.notificationService
                          .showSuccess(
                            "¡Se solicitó correctamente la eliminación de la Observación Anterior!"
                          )
                      });
                    this.onSubmitModif();
                  } else if (result === false) {
                    // Usuario eligió "No Borrar"
                    this.onSubmitModif();
                  } else if (result === 'third') {
                    // Usuario eligió "Cancelar" - No hacer nada, cortar el flujo
                  }
                });
            } else {
              this.onSubmitModif();
            }
          } else {
            this.onSubmitModif();
          }
        }
      });
  }

  formatoTimeDis() {
    this.columnsVisible.forEach((column: EstructuraDinamicaField) => {
      let value = this.form.controls[column.name]?.value;
      const typeInput = ["time", "date"];


      const validate = (value !== null && value !== "" && value !== undefined)
      if (validate && typeInput.includes(column.inputType)) {

        if (column.inputType === "time" && String(value).includes(':')) {
          const formatTime = value.replace(':', '');
          this.form.controls[column.name]?.setValue(formatTime);
          column.value = formatTime;
        }

        if (column.inputType === "date" && column.pattern === "YYYYMM" && String(value).includes('-')) {
          const fomartDate = this.form.controls[column.name].value.replace('-', '');
          this.form.controls[column.name]?.setValue(fomartDate);
          column.value = fomartDate;
        }

        if (column.inputType === "date" && column.pattern === "AAAAMMDD" && String(value).includes('-')) {
          const fomartDate = this.form.controls[column.name].value.split("-").join("");
          column.value = fomartDate;
          this.form.controls[column.name]?.setValue(fomartDate);
        }

        if (column.inputType === "date" && column.pattern === "YYYY-MM-DD") {
          const fomartDate = this.form.controls[column.name].value;
          column.value = fomartDate;
          this.form.controls[column.name]?.setValue(fomartDate);
        }


        if (column.inputType === "date" && column.pattern === "DD-MM-YYYY" && String(value).includes('-')) {
          const fomartDate = this.form.controls[column.name].value.split("-");
          const newValue = `${fomartDate[2]}-${fomartDate[1]}-${fomartDate[0]}`;
          column.value = newValue;
          this.form.controls[column.name]?.setValue(newValue);
        }

        if (column.inputType === "date" && column.pattern === "YYYY-MM" && String(value).includes('-')) {
          const fomartDate = this.form.controls[column.name].value.split("-");
          const newValue = `${fomartDate[0]}-${fomartDate[1]}}`;
          column.value = newValue;
          this.form.controls[column.name]?.setValue(newValue);
        }

        if (column.inputType === "date" && column.pattern === "DDMMAAAA" && String(value).includes('-')) {
          const fomartDate = this.form.controls[column.name].value.split("-").join("");
          const value = `${fomartDate.slice(-2)}${fomartDate.slice(4, 6)}${fomartDate.slice(0, 4)}`
          column.value = value;
          this.form.controls[column.name]?.setValue(value);
        }

      }
    });
  }

  onSubmit() {

    // efx-dropdown (multiselect) pisa el form control con undefined en su ngOnChanges,
    // pero conserva la selección real en option.selected. Antes de detectar cambios y
    // construir el payload, reconstruimos el valor del form desde esas opciones.
    this.syncMultiSelectFormValuesFromOptions();

    this.atributosFuenteModif = [];

    let atributosFuenteModifText = [];
    const keyUpdates = [];

    // Detectar si estamos restaurando un registro histórico (journalingTimestamp diferente)
    // IMPORTANTE: Usar String() para evitar inconsistencias entre tipos (number vs string)
    const currentTimestamp = String(this.selectedFuenteDinamica?.journalingTimestamp ?? '');
    const backupTimestamp = String(this.selectedFuenteDinamicaBackUp?.journalingTimestamp ?? '');
    const isHistoricalRestore = currentTimestamp !== backupTimestamp;

    // Log para diagnóstico de problemas de restauración de historial
    console.log('[FD-Detail] onSubmit - Detección de restauración:', {
      currentTimestamp,
      backupTimestamp,
      isHistoricalRestore,
      formDirty: this.form?.dirty
    });

    for (const key in this.form.controls) {
      const columnDef = this.columnsVisible.find((item) => item.name === key);
      if (!columnDef) continue; // Control no visible en la UI, ignorar

      const isDirty = this.form.get([key]).dirty;
      // En restauración de historial: incluir también campos que difieren del registro actual
      const isMapType = columnDef?.type === 'map';
      const rawFormValue = this.form.value[key] ?? '';
      const rawBackupValue = this.selectedFuenteDinamicaBackUp?.[key] ?? '';
      let formValue = isMapType
        ? JSON.stringify(rawFormValue)
        : String(rawFormValue);
      let backupValue = isMapType
        ? JSON.stringify(rawBackupValue)
        : String(rawBackupValue);

      // Para campos de tipo fecha, normalizar ambos valores al formato ISO usando el patrón
      // para comparación correcta (datepicker usa ISO "2020-04-16", datos usan formato del patrón ej: "20200416")
      if (columnDef.inputType === 'date' && columnDef.pattern && formValue && backupValue) {
        // Normalizar backupValue (formato patrón) a ISO usando validateFormatDate
        const normalizedBackup = this.sharedService.validateFormatDate(columnDef.pattern, backupValue);
        // formValue ya viene en ISO del datepicker, pero si viene en formato patrón también normalizamos
        const normalizedForm = formValue.includes('-') ? formValue : this.sharedService.validateFormatDate(columnDef.pattern, formValue);
        formValue = normalizedForm;
        backupValue = normalizedBackup;
      }

      // Para campos de tipo time, normalizar ambos valores al formato con ":"
      // para comparación correcta (timepicker usa "14:30", datos usan "1430")
      if (columnDef.inputType === 'time' && formValue && backupValue) {
        // Normalizar ambos al formato con ":" para comparación
        const normalizeTime = (val: string): string => {
          // Si ya tiene ":", está normalizado
          if (val.includes(':')) return val;
          // Si es formato HHMM (4 dígitos), convertir a HH:MM
          if (/^\d{4}$/.test(val)) return `${val.slice(0, 2)}:${val.slice(2, 4)}`;
          // Si es formato HHMMSS (6 dígitos), convertir a HH:MM:SS
          if (/^\d{6}$/.test(val)) return `${val.slice(0, 2)}:${val.slice(2, 4)}:${val.slice(4, 6)}`;
          return val;
        };
        formValue = normalizeTime(formValue);
        backupValue = normalizeTime(backupValue);
      }

      const differsFromCurrent = isHistoricalRestore && formValue !== backupValue;

      // Log para diagnóstico de cada campo
      if (isDirty || differsFromCurrent) {
        console.log(`[FD-Detail] Campo incluido: ${key}`, { isDirty, differsFromCurrent, formValue, backupValue });
        keyUpdates.push(key);
        atributosFuenteModifText.push(`<b>${columnDef.label}</b>`);
        this.atributosFuenteModif.push(columnDef.name);
      }
    }

    console.log('[FD-Detail] onSubmit - Campos modificados finales:', this.atributosFuenteModif);

    if (this.form.valid) {
      this.localStorageService.keyUpdates = keyUpdates;
      this.confirmationDialog(atributosFuenteModifText, this.atributosFuenteModif);
    }
  }

  onSubmitModif() {
    if (this.isAdding) {
      let aux = { ...this.selectedFuenteDinamica, ...this.form.value }
      this.selectedFuenteDinamica = aux;
      this.fuenteDinamicaData = aux;
    }

    queueMicrotask(() => {
      this.submitDIS();
      this.initStructDinamy();
      this.cdr.detectChanges();
    });
  }

  /**
   * Construye el payload para DIS v2 directamente desde this.struct, sin depender de
   * this.dataviews (que puede estar vacío en plataforma VIP).
   *
   * Itera sobre todos los campos de la estructura, obtiene sus valores del formulario /
   * selectedFuenteDinamica, convierte el tipo Avro a partir de field.type + field.nullable
   * y serializa con serializeAvroValue. El campo "keying" se obtiene vía consumeKeying.
   *
   * Formato DIS v2:
   * {
   *   data: ["<json_avro_string>"],
   *   purposingProfiles: [...],   // Opcional: profiles de purposing (Delta)
   *   audit: { ... }
   * }
   */
  private async buildDisV2PayloadFromStruct(auditData: any): Promise<any> {
    const formValues = this.form.value;
    const disObject: any = {};

    // 1. keying - usar el método apropiado según si es alta de entidades o no
    let keying: any;
    if (this.localStorageService.esAltaEntidades) {
      keying = await this.fuenteDinamicaService.consumeKeyingAddEntity(formValues);
    } else {
      keying = await this.fuenteDinamicaService.consumeKeying(
        { ...formValues },
        this.atributosFuenteModif,
        this.SUB_DOMAIN_JO,
        this.currentCountry.toUpperCase(),
        this.typeServiceMenu,
        this.isAdding // true para nueva observación, false para modificación
      );
    }
    disObject['keying'] = keying;

    // 2. All data fields from struct
    for (const field of (this.struct || [])) {
      const fieldName = field.name;
      if (fieldName === 'matchKey' || fieldName === 'keying') continue;

      // Caso especial: denominación para NATURAL_PERSON AR (igual que dataToSaveDISfromDataview)
      let value: any;
      if (fieldName === 'denominacion' && this.SUB_DOMAIN_JO === 'NATURAL_PERSON' && this.currentCountry.toUpperCase() === 'AR') {
        value = (formValues.apellidos || '') + ',' + (formValues.nombres || '');
      } else {
        // Reuse existing value-resolution logic (handles FieldsSourceDIS special fields)
        value = this.returnValueDISDataview(formValues, field);
      }

      // Construir tipo Avro según el campo
      let avroType: any;
      if (field.isMultiSelect) {
        // Un multiselect produce múltiples valores; no caben en un escalar boolean/int.
        // Se persiste como string con los códigos unidos por coma (ej. "true,false").
        // El campo en el schema DIS debe ser de tipo string para aceptarlo.
        if (Array.isArray(value)) {
          value = value.join(',');
        }
        avroType = field.nullable === false ? 'string' : ['string', 'null'];
      } else if (field.type === 'array' && field.subFields?.length > 0) {
        // Array con subFields explícitos: construir tipo record con nullable de cada subcampo
        avroType = {
          type: 'array',
          items: {
            type: 'record',
            fields: field.subFields.map(sf => ({
              name: sf.name,
              type: sf.nullable !== false ? ['null', sf.type || 'string'] : (sf.type || 'string')
            }))
          }
        };
        if (field.nullable) avroType = [avroType, 'null'];
      } else if (field.type === 'array' && Array.isArray(value) && value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
        // Array sin subFields en la config, pero el valor real tiene objetos → inferir estructura dinámica
        const sampleItem = value[0];
        const inferredFields = Object.keys(sampleItem).map(key => ({
          name: key,
          type: ['null', 'string'] as any
        }));
        avroType = {
          type: 'array',
          items: {
            type: 'record',
            fields: inferredFields
          }
        };
        if (field.nullable !== false) avroType = [avroType, 'null'];
      } else {
        // Campo simple: nullable true → ["tipo", "null"], false → "tipo"
        avroType = field.nullable === true ? [field.type, 'null'] : field.type;
      }
      disObject[fieldName] = this.sharedService.serializeAvroValue(avroType, value);
    }

    // 3. Serialize with BigInt support (same as dataToSaveDISfromDataview)
    const serializedRecord = this.serializeBigIntObject(disObject);

    // Registrar en el audit los campos que FieldsSourceDIS aplicó automáticamente
    const autoFieldsTemp: Record<string, any> = {};
    const autoFieldsV2 = this.applyFieldsSourceDIS(autoFieldsTemp);
    // En edición, el before viene de selectedFuenteDinamica; en alta no hay before
    const sourceDataV2 = this.isAdding ? null : this.selectedFuenteDinamica;
    this.mergeFieldsSourceDISIntoAudit(auditData, autoFieldsV2, sourceDataV2);

    const payload: any = { data: [serializedRecord], audit: auditData };

    // 4. PurposingProfiles (mismo criterio que DIS Global v1)
    const purposing = this.localStorageService.subdomainPurp;
    if (purposing !== '') {
      payload.purposingProfiles = [purposing];
    }
    const header = this.localStorageService.dataEstructuraDinamicaHeader;
    if (header?.purposingProfileList?.length > 0) {
      payload.purposingProfiles = header.purposingProfileList;
    }

    return payload;
  }

  /**
   * Construye el payload para DIS Global v1 (edición de observación existente).
   *
   * Formato DIS Global:
   * {
   *   entityKey: "...",           // Campos del matchkey (top-level) para identificar la observación
   *   iup: "...",                 // en Journaling
   *   newValues: {                // Solo los campos que cambiaron (valores planos, sin Avro)
   *     campo1: "valor1",
   *     campo2: "valor2"
   *   },
   *   purposingProfiles: [...],   // Opcional: profiles de purposing (Delta)
   *   audit: { ... }              // Opcional: datos de auditoría
   * }
   *
   * El backend obtiene la última observación en Journaling usando el matchKey (string),
   * aplica los newValues y ejecuta la ingesta incluyendo keying automáticamente.
   *
   * Formato:
   * {
   *   matchKey: "ENTITY_KEY.IUP.CAMPO3...",   // matchKey completo del registro
   *   newValues: {
   *     campo: valor, ...,
   *     "keying.profileId": "dfkl_ar_profile_..."  // solo para fuentes K&L (GKL)
   *   },
   *   purposingProfiles?: [...],
   *   audit: { ... }
   * }
   */
  private async buildDisGlobalPayload(auditData: any): Promise<any> {
    // Enviar el matchKey completo como string directo.
    // El backend acepta el campo "matchKey" y lo usa para consultar Journaling
    // sin necesidad de enviar cada campo por separado ni resolver hashes.
    const header = this.localStorageService.dataEstructuraDinamicaHeader;
    const record = this.selectedFuenteDinamica || {};

    const body: any = {};
    // Usar data.header en lugar de matchKey
    const dataHeader = (record as any)['data.header'];
    if (dataHeader) {
      body.matchKey = encodeURIComponent(String(dataHeader));
    } else {
      console.warn('[FD-Detail] El registro no tiene data.header, el backend podría rechazar la petición.', record);
    }

    // Detectar si estamos restaurando un registro histórico
    // IMPORTANTE: Usar String() para evitar inconsistencias entre tipos (number vs string)
    const currentTimestamp = String((record as any)?.journalingTimestamp ?? '');
    const backupTimestamp = String(this.selectedFuenteDinamicaBackUp?.journalingTimestamp ?? '');
    const isHistoricalRestore = currentTimestamp !== backupTimestamp;

    // Log para diagnóstico
    console.log('[FD-Detail] buildDisGlobalPayload - Detección de restauración:', {
      currentTimestamp,
      backupTimestamp,
      isHistoricalRestore,
      atributosFuenteModif: this.atributosFuenteModif
    });

    // Construir newValues solo con los campos modificados (valores planos, sin Avro wrapping)
    // Se respeta el tipo de dato definido en la estructura (int, double, boolean, string)
    const newValues: Record<string, any> = {};

    // Si es restauración de historial, incluir TODOS los campos del registro histórico
    // que difieren del registro original (selectedFuenteDinamicaBackUp)
    if (isHistoricalRestore && this.selectedFuenteDinamicaBackUp) {
      console.log('[FD-Detail] Procesando restauración de historial...');
      // Recorrer todos los campos de la estructura
      for (const field of (this.struct || [])) {
        const fieldName = field.name;
        // Excluir campos internos y no editables del schema
        if (fieldName === 'matchKey' || fieldName === 'rowKey' || fieldName === 'keying' ||
          fieldName === 'data.header' || fieldName === 'journalingTimestamp' ||
          fieldName === 'recordAction' || fieldName === 'dfContributionName') continue;

        // Obtener valor del registro del historial (form tiene precedencia)
        const formHasField = this.form.value[fieldName] !== undefined;
        const historyValue = formHasField
          ? this.form.value[fieldName]
          : (this.selectedFuenteDinamica as any)?.[fieldName];
        const originalValue = (this.selectedFuenteDinamicaBackUp as any)?.[fieldName];

        const historyStr = String(historyValue ?? '');
        const originalStr = String(originalValue ?? '');
        const differs = historyStr !== originalStr;

        // Log detallado para diagnóstico
        if (differs) {
          console.log(`[FD-Detail] Campo difiere: ${fieldName}`, {
            formHasField,
            historyValue: historyStr,
            originalValue: originalStr
          });
        }

        // Comparar valores: incluir si difieren
        if (differs) {
          newValues[fieldName] = this.coerceToStructType(fieldName, historyValue);

          // Agregar campo asociado si existe Y el campo es de tipo select
          // (la asociación código-descripción solo aplica para campos select con variables categóricas)
          const fieldDef = this.struct?.find(s => s.name === fieldName);
          if (fieldDef?.associateField && fieldDef.inputType === 'select') {
            const associateFieldName = fieldDef.associateField;
            const associateValue = (this.selectedFuenteDinamica as any)?.[associateFieldName];
            if (associateValue !== undefined && !(associateFieldName in newValues)) {
              newValues[associateFieldName] = this.coerceToStructType(associateFieldName, associateValue);
            }
          }
        }
      }

      console.log('[FD-Detail] Restauración de historial - campos que difieren:', Object.keys(newValues));
    } else {
      console.log('[FD-Detail] Flujo normal - procesando atributosFuenteModif:', this.atributosFuenteModif);
      // Flujo normal: solo campos modificados por el usuario
      for (const fieldName of this.atributosFuenteModif) {
        let value = this.form.value[fieldName];
        console.log(`[FD-Detail] Flujo normal - Campo: ${fieldName}, valor:`, value);
        // Caso especial: denominación para NATURAL_PERSON AR
        if (fieldName === 'denominacion' && this.SUB_DOMAIN_JO === 'NATURAL_PERSON' && this.currentCountry.toUpperCase() === 'AR') {
          value = this.form.value.apellidos + ',' + this.form.value.nombres;
        }
        newValues[fieldName] = this.coerceToStructType(fieldName, value);

        // Agregar campo asociado solo si el campo es de tipo select
        // (la asociación código-descripción solo aplica para campos select con variables categóricas)
        const fieldDef = this.struct?.find(s => s.name === fieldName);
        if (fieldDef?.associateField && fieldDef.inputType === 'select') {
          const associateFieldName = fieldDef.associateField;
          const associateValue = this.selectedFuenteDinamica[associateFieldName];
          if (associateValue !== undefined && !(associateFieldName in newValues)) {
            newValues[associateFieldName] = this.coerceToStructType(associateFieldName, associateValue);
          }
        }
      }
    }

    // Caso especial NATURAL_PERSON AR: calcular 'denominacion' si se modifican 'apellidos' o 'nombres'
    // En DIS v2 esto se hacía automáticamente al iterar todo el schema, pero en DIS Global
    // solo iteramos campos modificados, así que debemos calcularlo explícitamente.
    if (this.SUB_DOMAIN_JO === 'NATURAL_PERSON' && this.currentCountry.toUpperCase() === 'AR') {
      const modifiedNombreApellido = ('apellidos' in newValues) || ('nombres' in newValues) ||
        this.atributosFuenteModif.includes('apellidos') || this.atributosFuenteModif.includes('nombres');
      if (modifiedNombreApellido && !('denominacion' in newValues)) {
        const apellidos = this.form.value.apellidos || this.selectedFuenteDinamica?.['apellidos'] || '';
        const nombres = this.form.value.nombres || this.selectedFuenteDinamica?.['nombres'] || '';
        newValues['denominacion'] = this.coerceToStructType('denominacion', apellidos + ',' + nombres);
      }
    }

    // Inyectar campos especiales de FieldsSourceDIS (fecha_insercion, operacion_tipo, etc.)
    const autoFieldsDISGlobal = this.applyFieldsSourceDIS(newValues);
    this.mergeFieldsSourceDISIntoAudit(auditData, autoFieldsDISGlobal, this.selectedFuenteDinamica);

    // ── keying.profileId: enviar el profileId de edición como campo prefijado ──
    // Solo para fuentes K&L (GKL). El backend usa "keying.profileId" para setear
    // el profile en el objeto keying de la observación.
    // Prioridad: 1) header ABM, 2) servicio GET de región, 3) keying original del registro
    const isGkl = this.typeServiceMenu?.toUpperCase() !== 'HASH';
    if (isGkl) {
      const headerProfiles = header?.profiles;
      const countryCode = this.currentCountry.toUpperCase();
      const regionProfiles = await this.fuenteDinamicaService.getRegionProfiles(countryCode);

      // Determinar entityType del registro (CONSUMER por defecto)
      const recordKeying = (record as any).keying;
      const entityType = recordKeying?.[0]?.request?.session?.entityType || 'CONSUMER';
      const originalProfileId = recordKeying?.[0]?.request?.session?.profileId || '';


      const profileId = entityType === 'COMMERCIAL'
        ? (headerProfiles?.editionCommercial || regionProfiles?.editionCommercial)
        : (headerProfiles?.editionConsumer || regionProfiles?.editionConsumer);

      if (profileId) {
        newValues['keying.profileId'] = profileId;
      }
    }

    body.newValues = newValues;
    body.audit = auditData;

    // PurposingProfiles
    const purposing = this.localStorageService.subdomainPurp;
    if (purposing !== '') {
      body.purposingProfiles = [purposing];
    }
    if (header?.purposingProfileList?.length > 0) {
      body.purposingProfiles = header.purposingProfileList;
    }

    console.log('[FD-Detail] buildDisGlobalPayload - Payload final:', {
      matchKey: body.matchKey,
      newValuesKeys: Object.keys(body.newValues || {}),
      newValues: body.newValues
    });

    return body;
  }

  /**
   * Construye el payload para DIS Global v1 (ingesta/creación de nueva observación o entidad).
   *
   * Formato DIS Global para creación:
   * {
   *   newValues: {                // Todos los campos mandatorios del formulario (valores planos)
   *     campo1: "valor1",
   *     campo2: "valor2"
   *   },
   *   newIngest: {                // Keying para K&L (sin wrapping Avro), vacío para no-K&L
   *     request: {
   *       session: { profileId, entityType, ... },
   *       entity: { consumer: {...} | commercial: {...} }
   *     }
   *   },
   *   purposingProfiles: [...],   // Opcional: profiles de purposing (Delta)
   *   audit: { ... }              // Opcional: datos de auditoría
   * }
   *
   * A diferencia de la edición, NO se envían campos de matchkey como top-level
   * porque no existe una observación previa en Journaling.
   */
  private async buildDisGlobalCreatePayload(auditData: any): Promise<any> {
    const body: any = {};

    // Construir newValues con todos los campos del formulario (valores planos, sin Avro wrapping)
    // Se respeta el tipo de dato definido en la estructura (int, double, boolean, string)
    const newValues: Record<string, any> = {};
    const formValue = this.form.value;
    for (const fieldName of Object.keys(formValue)) {
      // Excluir campos internos que no son parte de la observación
      if (fieldName === 'matchKey' || fieldName === 'rowKey') continue;

      let value = formValue[fieldName];
      // Caso especial: denominación para NATURAL_PERSON AR
      if (fieldName === 'denominacion' && this.SUB_DOMAIN_JO === 'NATURAL_PERSON' && this.currentCountry.toUpperCase() === 'AR') {
        value = (formValue.apellidos || '') + ',' + (formValue.nombres || '');
      }
      newValues[fieldName] = this.coerceToStructType(fieldName, value);

      // Agregar el campo de descripción asociado si existe Y el campo es de tipo select
      // (ej: residentialConditionCod → residentialConditionDes)
      // La asociación código-descripción solo aplica para campos select con variables categóricas
      // El método associateField() ya actualizó selectedFuenteDinamica con el texto de descripción
      const fieldDef = this.struct?.find(s => s.name === fieldName);
      if (fieldDef?.associateField && fieldDef.inputType === 'select') {
        const associateFieldName = fieldDef.associateField;
        const associateValue = this.selectedFuenteDinamica?.[associateFieldName];
        if (associateValue !== undefined && !(associateFieldName in newValues)) {
          newValues[associateFieldName] = this.coerceToStructType(associateFieldName, associateValue);
        }
      }
    }

    // Incluir campos no-editables del struct que tienen valor en fuenteDinamicaData
    // (ej: operacion_tipo, fuente_tipo, operacion_fh, usuario, fuente — sección OPERACIONES)
    // Estos campos no tienen form control porque editable=false, pero son mandatorios para DIS.
    if (this.struct) {
      for (const field of this.struct) {
        if (field.name in newValues || field.name === 'matchKey' || field.name === 'rowKey') continue;
        const dataValue = this.fuenteDinamicaData?.[field.name];
        if (dataValue !== undefined && dataValue !== null) {
          newValues[field.name] = this.coerceToStructType(field.name, dataValue);
        }
      }
    }

    // Caso especial NATURAL_PERSON AR: calcular 'denominacion' a partir de apellidos y nombres
    // En DIS v2 esto se hacía automáticamente al iterar todo el schema, pero en DIS Global
    // debemos calcularlo explícitamente ya que 'denominacion' puede no tener form control.
    if (this.SUB_DOMAIN_JO === 'NATURAL_PERSON' && this.currentCountry.toUpperCase() === 'AR') {
      const apellidos = formValue.apellidos || this.fuenteDinamicaData?.['apellidos'] || '';
      const nombres = formValue.nombres || this.fuenteDinamicaData?.['nombres'] || '';
      if ((apellidos || nombres) && !('denominacion' in newValues)) {
        newValues['denominacion'] = this.coerceToStructType('denominacion', apellidos + ',' + nombres);
      }
    }

    // Inyectar campos especiales de FieldsSourceDIS (fecha_insercion, operacion_tipo, etc.)
    const autoFieldsDISCreate = this.applyFieldsSourceDIS(newValues);
    this.mergeFieldsSourceDISIntoAudit(auditData, autoFieldsDISCreate);

    // Para nuevas ingestas, operacion_tipo debe ser "ALTA" (no "MODIF")
    if ('operacion_tipo' in newValues) {
      newValues['operacion_tipo'] = 'ALTA';
    }

    body.newValues = newValues;
    body.audit = auditData;

    // newIngest: generar keying para países GKL, vacío para HASH
    const isGkl = this.typeServiceMenu?.toUpperCase() !== 'HASH';
    if (isGkl) {
      const valuesForKeying = { ...formValue };
      const keying = this.localStorageService.esAltaEntidades
        ? await this.fuenteDinamicaService.consumeKeyingAddEntity(valuesForKeying)
        : await this.fuenteDinamicaService.consumeKeying(
          valuesForKeying,
          Object.keys(newValues),
          this.SUB_DOMAIN_JO,
          this.currentCountry.toUpperCase(),
          this.typeServiceMenu,
          true // isAdding = true → usa perfiles de ingesta
        );

      if (keying && Array.isArray(keying) && keying.length > 0) {
        body.newIngest = this.unwrapKeyingForGlobal(keying[0]);
      }
    } else {
      // Fuentes no-K&L (HASH): enviar newIngest vacío según documentación DIS
      body.newIngest = {};
    }

    // PurposingProfiles
    const purposing = this.localStorageService.subdomainPurp;
    if (purposing !== '') {
      body.purposingProfiles = [purposing];
    }
    const header = this.localStorageService.dataEstructuraDinamicaHeader;
    if (header?.purposingProfileList?.length > 0) {
      body.purposingProfiles = header.purposingProfileList;
    }


    return body;
  }

  /**
   * Coerce un valor de formulario al tipo JS correcto según la definición en `this.struct`.
   * DIS Global espera tipos nativos (int → number, double → number, boolean → boolean).
   * Para tipos no-string, un valor vacío ('') se convierte a null.
   * También maneja campos tipo 'array' con subFields, procesando cada elemento.
   */
  private coerceToStructType(fieldName: string, value: any): any {
    if (value === null || value === undefined) return value;
    const fieldDef = this.struct?.find(s => s.name === fieldName);
    if (!fieldDef) return value;
    // Multiselect: persistir los códigos como string unido por coma (igual que DIS v2 via toString)
    if (fieldDef.isMultiSelect && Array.isArray(value)) {
      return value.join(',');
    }
    // Resolver tipo: manejar Avro union arrays como ["null", "int"]
    const rawType = Array.isArray(fieldDef.type)
      ? fieldDef.type.find((t: any) => t !== 'null')
      : fieldDef.type;
    const type = typeof rawType === 'object' ? rawType?.type : rawType;
    // Un string vacío para tipos no-string debe ser null (ej. data_date int vacío → null)
    if (value === '' && type !== 'string') return null;
    switch (type) {
      case 'int': {
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? null : parsed;
      }
      case 'long': {
        // Para campos 'long', enviarlos como string al DIS Global para evitar
        // problemas de precisión en valores muy grandes en JavaScript.
        // El backend convertirá el string a long en la ingesta.
        // Ejemplo: upload_date "20120119131957001" debe ir como string, no como número.
        const stringValue = String(value).trim();
        const parsed = parseInt(stringValue, 10);
        return isNaN(parsed) ? null : stringValue;
      }
      case 'float':
      case 'double': {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? null : parsed;
      }
      case 'boolean':
        return value === 'true' || value === true;
      case 'array': {
        // Campos tipo array con subFields: procesar cada elemento del array
        // usando la misma lógica que createObjectDISArray pero sin wrapping Avro
        if (!Array.isArray(value)) return value;
        const subFields = fieldDef.subFields;
        if (!subFields || subFields.length === 0) return value;
        return this.coerceArrayForGlobal(value, subFields);
      }
      default:
        return value;
    }
  }

  /**
   * Procesa un campo tipo array para DIS Global, convirtiendo cada elemento
   * a su tipo correcto sin wrapping Avro (a diferencia de createObjectDISArray).
   * @param arrayValue - Array de objetos del formulario
   * @param subFields - Definición de campos dentro del array
   * @returns Array procesado con tipos correctos
   */
  private coerceArrayForGlobal(arrayValue: any[], subFields: any[]): any[] {
    if (!arrayValue || !Array.isArray(arrayValue)) return arrayValue;

    return arrayValue.map(item => {
      const coercedItem: Record<string, any> = {};
      for (const subField of subFields) {
        const key = subField.name;
        const currentValue = item[key];
        // Resolver tipo del subField
        const rawType = Array.isArray(subField.type)
          ? subField.type.find((t: any) => t !== 'null')
          : subField.type;
        const type = typeof rawType === 'object' ? rawType?.type : rawType;

        // Coercer el valor al tipo correcto (sin wrapping Avro)
        if (currentValue === null || currentValue === undefined) {
          coercedItem[key] = currentValue;
        } else if (currentValue === '' && type !== 'string') {
          coercedItem[key] = null;
        } else {
          switch (type) {
            case 'int':
              const intParsed = parseInt(currentValue, 10);
              coercedItem[key] = isNaN(intParsed) ? null : intParsed;
              break;
            case 'long':
              const longStr = String(currentValue).trim();
              const longParsed = parseInt(longStr, 10);
              coercedItem[key] = isNaN(longParsed) ? null : longStr;
              break;
            case 'float':
            case 'double':
              const floatParsed = parseFloat(currentValue);
              coercedItem[key] = isNaN(floatParsed) ? null : floatParsed;
              break;
            case 'boolean':
              coercedItem[key] = currentValue === 'true' || currentValue === true;
              break;
            default:
              coercedItem[key] = currentValue;
          }
        }
      }
      return coercedItem;
    });
  }

  /**
   * Aplica las transformaciones de FieldsSourceDIS sobre el objeto newValues.
   * Inyecta campos especiales por país/dominio/subdominio como fecha_insercion,
   * operacion_tipo, fuente_tipo, usuario_modificacion, etc.
   * Retorna un Record con los campos que fueron efectivamente aplicados y sus valores,
   * para que el llamador pueda registrarlos en el audit.
   */
  private applyFieldsSourceDIS(newValues: Record<string, any>): Record<string, any> {
    // Obtener los nombres de campos válidos del struct actual para no inyectar
    // campos que no existen en el esquema de la fuente (ej: sourceType no existe en LEGAL_ENTITY)
    const structFieldNames = new Set((this.struct || []).map(f => f.name?.toUpperCase()));
    const appliedFields: Record<string, any> = {};

    FieldsSourceDIS.forEach((itemCountry: IFieldsSourceDIS) => {
      if (itemCountry.country?.toUpperCase() === this.localStorageService.getSourceCountrySelected) {
        itemCountry.fields?.forEach((item: IFieldFieldsSourceDIS) => {
          if (item.domain && item.domain.toUpperCase() !== this.localStorageService.getSourceDomainSelected) return;
          if (item.subdomain && item.subdomain.toUpperCase() !== this.localStorageService.getSourceSubDomainSelected) return;
          if (!structFieldNames.has(item.field?.toUpperCase())) return;

          let resolvedValue: any;
          switch (item.type) {
            case 'text':
              resolvedValue = item.value;
              break;
            case 'user':
              resolvedValue = this.localStorageService.dataLogin.getUser()?.toUpperCase() + ' - ' + this.localStorageService.dataLogin.getName()?.toUpperCase();
              break;
            case 'fuente':
              resolvedValue = this.localStorageService.getIsVip ? 'VIP' : 'DATA MAINTENANCE';
              break;
            case 'current_date':
              resolvedValue = parseInt(this.datesTimesService.getCurrentDate());
              break;
            case 'current_date_time':
              resolvedValue = this.datesTimesService.getCurrentDateTime();
              break;
            case 'current_date_adding':
              if (this.isAdding) {
                resolvedValue = parseInt(this.datesTimesService.getCurrentDate());
              }
              break;
            case 'current_date_time_adding':
              if (this.isAdding) {
                resolvedValue = parseInt(this.datesTimesService.getCurrentDateTime());
              }
              break;
          }

          if (resolvedValue !== undefined) {
            newValues[item.field] = resolvedValue;
            appliedFields[item.field] = resolvedValue;
          }
        });
      }
    });

    return appliedFields;
  }

  /**
   * Fusiona los campos aplicados automáticamente por FieldsSourceDIS en auditData.fields.
   * Cada campo automático se registra como { before: valorOriginal, after: valorNuevo, auto: true }.
   * @param auditData     Objeto de auditoría a modificar.
   * @param appliedFields Campos aplicados automáticamente con sus nuevos valores.
   * @param sourceData    Datos originales del registro (para extraer el before). Null en creación.
   */
  private mergeFieldsSourceDISIntoAudit(
    auditData: any,
    appliedFields: Record<string, any>,
    sourceData?: Record<string, any> | null
  ): void {
    if (!auditData || Object.keys(appliedFields).length === 0) return;
    if (!auditData.fields) {
      auditData.fields = {};
    }
    for (const fieldName of Object.keys(appliedFields)) {
      const before = sourceData != null ? (sourceData[fieldName] ?? null) : null;
      auditData.fields[fieldName] = { before, after: appliedFields[fieldName], auto: true };
    }
  }

  /**
   * Quita el wrapping Avro del keying para que DIS Global lo reciba en formato plano.
   * Elimina namespaces como "com.equifax.fabric.keying.common.v1.Session" dejando el objeto interno.
   * También elimina response y entity types nulos.
   */
  private unwrapKeyingForGlobal(keyingItem: any): any {
    const raw = JSON.parse(JSON.stringify(keyingItem));

    // Eliminar response (no se necesita en DIS Global)
    delete raw.response;

    // Unwrap session: { "com.equifax...Session": {...} } → {...}
    if (raw.request?.session) {
      const sessionVal = raw.request.session;
      const sessionKeys = Object.keys(sessionVal);
      if (sessionKeys.length === 1 && sessionKeys[0].includes('.')) {
        raw.request.session = sessionVal[sessionKeys[0]];
      }
    }

    // Unwrap consumer: { "com.equifax...Consumer": {...} } → {...}
    if (raw.request?.entity?.consumer && typeof raw.request.entity.consumer === 'object') {
      const consumerVal = raw.request.entity.consumer;
      const consumerKeys = Object.keys(consumerVal);
      if (consumerKeys.length === 1 && consumerKeys[0].includes('.')) {
        raw.request.entity.consumer = consumerVal[consumerKeys[0]];
      }
    }

    // Unwrap commercial: { "com.equifax...Commercial": {...} } → {...}
    if (raw.request?.entity?.commercial && typeof raw.request.entity.commercial === 'object') {
      const commercialVal = raw.request.entity.commercial;
      const commercialKeys = Object.keys(commercialVal);
      if (commercialKeys.length === 1 && commercialKeys[0].includes('.')) {
        raw.request.entity.commercial = commercialVal[commercialKeys[0]];
      }
    }

    // Eliminar entity types nulos (consumer: null o commercial: null)
    if (raw.request?.entity) {
      if (raw.request.entity.consumer === null) delete raw.request.entity.consumer;
      if (raw.request.entity.commercial === null) delete raw.request.entity.commercial;
    }

    return raw;
  }

  async submitDIS() {
    this.formatoTimeDis();
    this.associateField();
    this.comparteTempModal();
    this.setDataTemplateDIS();

    const country = (this.currentCountry.toUpperCase() === "AR")
      ? "ar"
      : this.currentCountry.toUpperCase();

    // Caso especial: Contribución UY VIP - termina el flujo aquí
    if (this.isAdding && this.localStorageService.getIsVip && country.toUpperCase() === 'UY' && this.SUB_DOMAIN_JO == "CREDIT_DEFAULT") {

      this.contribution(country);
      return;
    }

    const isRds = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS;

    // Solo procesamos dataviews para RDS modify (DIS Global edits/creates construyen su propio payload)
    let dataToSaveDISfromDataview;
    if (isRds) {
      this.initDataViews();
      dataToSaveDISfromDataview = await this.dataToSaveDISfromDataview(this.selectedFuenteDinamica, this.dataviews);
    }

    // Calcular currentMatchKeyOld y currentMatchKeyNew (necesario para reloadList)
    let currentMatchKeyOld = this.selectedFuenteDinamica['matchKey'];
    if (this.localStorageService.getIsExternoRDS) {
      currentMatchKeyOld = this.localStorageService.getMatchkeySelected;
    }

    let matchKeyHeader = currentMatchKeyOld;
    if (currentMatchKeyOld == null) {
      matchKeyHeader = "";
    }

    const sep = this.localStorageService.dataEstructuraDinamicaHeader?.separator || '.';
    let matchKeyHeaderArray = matchKeyHeader.split(sep);
    let matchKeyHeaderObj = {};
    let currentMatchKeyNew = '';

    if (this.currentCountry === 'ar') { // TODO: hacer esto dinámico en STRUCT o MENU
      let matchKeyHeaderArraySalida = [];
      matchKeyHeaderArray.forEach(element => {
        matchKeyHeaderArraySalida.push(matchKeyHeaderObj[element]);
      });
      currentMatchKeyNew = matchKeyHeaderArraySalida.join(sep);
    }

    const objParams = {
      headers: this.fuenteDinamicaService.getTokenToHeaders(),
    };

    // FLUJO 1: Agregar nuevo registro en RDS
    if (this.isAdding && isRds) {
      const value = this.form.value;

      delete value.matchKey;
      delete value.rowKey;

      const auditData = this.auditService.buildAuditForFuenteDinamica(
        country,
        this.localStorageService.esInternoRDS,
        currentMatchKeyOld,
        this.fuenteDinamicaData,
        this.localStorageService.cambiosGFD
      );
      const body = {
        data: {
          ...value,
        },
        audit: auditData
      }

      this.fuenteDinamicaService.addRDS(this.currentCountry, this.SUB_DOMAIN_JO, body).subscribe({
        next: (response: any) => {
          this.localStorageService.setPrimarykeyRds = response.response[0].id

          this.notificationAlertService.show({
            title: '¡Los cambios se solicitaron correctamente!',
            type: 'success',
            mode: 'component',
            position: 'top-right',
            color: '#fff',
            maxWidth: '960px'
          });
          this.isAdding = false;
          this.onIsAdding.emit(this.isAdding);

          const currentMatchKeyOld = "";
          const currentMatchKeyNew = "";
          this.reloadList(
            currentMatchKeyOld,
            currentMatchKeyNew,
            country
          )
        }, error: (e) => {
          this.errorUpdate(e);
          this.validaDate();
        },
      })
    } else {
      // FLUJO 2: Modificar/Crear registro (DIS Global, DIS v2 o RDS)
      this.localStorageService.cambiosGFD = this.form;

      const auditData = this.auditService.buildAuditForFuenteDinamica(
        country,
        isRds,
        currentMatchKeyOld,
        this.fuenteDinamicaData,
        this.localStorageService.cambiosGFD
      );
      let body: any;

      // Detectar si estamos restaurando un registro histórico
      const currentTimestamp = String(this.selectedFuenteDinamica?.journalingTimestamp ?? '');
      const backupTimestamp = String(this.selectedFuenteDinamicaBackUp?.journalingTimestamp ?? '');
      const isHistoricalRestore = currentTimestamp !== backupTimestamp;

      // DIS v2 para todo lo que no sea RDS (más estable y rápido que DIS Global)
      // DIS v2 envía todos los campos con formato Avro
      // DIS Global está deprecado por problemas de rendimiento en PRD
      const useDisV2 = !isRds;

      console.log('[FD-Detail] submitDIS - Usando DIS v2', { isAdding: this.isAdding, isRds });

      if (useDisV2) {
        // ── DIS v2: crear o editar observación ──
        // Construye el payload desde this.struct con todos los campos en formato Avro.
        // DIS Global está deprecado por problemas de rendimiento en PRD.
        body = await this.buildDisV2PayloadFromStruct(auditData);

      } else {
        // ── RDS modify ──
        body = { audit: auditData };
        if (dataToSaveDISfromDataview) {
          Object.assign(body, dataToSaveDISfromDataview);
        }

        const purposing = this.localStorageService.subdomainPurp;
        if (purposing !== '') {
          body.purposingProfiles = [purposing];
        }

        const header = this.localStorageService.dataEstructuraDinamicaHeader;
        if (header && header.purposingProfileList &&
          Array.isArray(header.purposingProfileList) &&
          header.purposingProfileList.length > 0) {
          body.purposingProfiles = header.purposingProfileList;
        }
      }

      this.fuenteDinamicaService.modifyFuenteDinamica(
        country,
        this.SUB_DOMAIN_JO,
        body,
        objParams
      ).subscribe({
        next: (response: any) => {

          if (this.tempModal.state) {
            this.notificationService.muestraMensaje(this.tempModal.msg);
          }

          if (!isRds) {
            this.updateNominativo();
          }
          if (this.periods && this.periodsType === 'situation') {
            this.initStructPeriodsSituation(this.SUB_DOMAIN_JO, this.fuenteDinamicaData, true);
          } else if (!this.localStorageService.esAltaEntidades) {
            this.showCustom('success', 'Se guardó su modificación con Éxito!');
            this.dialog.closeAll();
            this.isEditing = false;
            this.emitIsEditing.emit(this.isEditing);
            let matchKeyOld = currentMatchKeyOld;
            let matchKeyNew = currentMatchKeyNew;
            if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
              matchKeyOld = "";
              matchKeyNew = "";
            }
            this.reloadList(matchKeyOld, matchKeyNew, this.currentCountry);
          }
        },
        error: (e) => {
          this.errorUpdate(e);
          this.validaDate();
        },
      });
    }
  }

  errorUpdate(e) {
    this.dialog.closeAll();
    if (e?.vipEmptyResponse) {
      this.notificationAlertService.show({ title: '¡Error al guardar! El servidor no confirmó la operación. Intente nuevamente.', type: 'error', mode: 'component', position: 'top-right', color: '#fff', maxWidth: '960px' });
    } else if (e.status === 403) {
      this.notificationService.showError("¡Error 403!.");
    } else if (e === "history") {
      this.notificationService.showInfo(`Observación sin historial`);
    } else {
      this.notificationService.showError(`¡Error particular. ${e.status}!`);
    }
  }

  onEdit() {
    if (this.editionMode) {
      this.isEditing = !this.isEditing;
      this.emitIsEditing.emit(this.isEditing);
      this.validaDate();
    } else {
      this.returnToList();
    }
  }

  formIsInvalid() {
    const compareSelectedData: boolean =
      this.selectedFuenteDinamica?.journalingTimestamp == this.selectedFuenteDinamicaBackUp?.journalingTimestamp;
    return compareSelectedData
      ? this.form?.invalid || !this.formIsDirty()
      : false;
  }

  formIsDirty() {
    return this.isSoftDelete ? true : this.form?.dirty;
  }

  onCancel() {
    if (this.form.dirty || this.localStorageService.esAltaEntidades) {
      this.confirmationDialogService
        .cancelEdit()
        .then((confirmed) => {
          if (confirmed) {
            this.initStructDinamy();
            this.onEdit();
            if (this.isAdding && !this.localStorageService.esAltaEntidades) this.returnToList();
            else if (this.localStorageService.esAltaEntidades) this.redireccionBuscador();
          }
        })
        .catch(() =>
          console.error("error en modal de descartar cambios en modificación")
        );
    } else {
      this.onEdit();
      this.isAdding && this.returnToList();
    }
  }

  redireccionBuscador() {
    const dmApp: IMenuData = MenuAppsModel.find(menuOption => menuOption.title === OptionMenuApps.DM);
    this.localStorageService.setMenuApp = dmApp;

    const path = window.location.pathname;
    const segments = path.split('/');

    const firstSegment = segments[1];

    const url = `${firstSegment}/dm/search/${this.currentCountry}`;

    this.router.navigateByUrl(
      this.localStorageService.getIsVip
        ? environment.URL_RETURN_APP_VIP
        : this.localStorageService.getIsExternoRDS
          ? environment.URL_RETURN_APP_RDS
          : url
    );
  }

  // TODO: revisar, se está llamando este método desde el html, por tanto queda siempre pidiéndolo
  mostrarDataSelect(itemValue: any[], itemName: string, editable: boolean) {
    const valueSelect: number = this.fuenteDinamicaData[itemName];
    if (valueSelect && editable) {
      this.fuenteDinamicaData[itemName] = this.sharedService.multiCodeSelectStruc(
        itemValue,
        valueSelect
      );
      this.form.controls[itemName]?.setValue(this.fuenteDinamicaData[itemName]);
    }
    let itemNameValue = this.fuenteDinamicaData[itemName];

    return this.sharedService.mostrarDataSelectGFD(
      itemNameValue,
      itemValue,
      itemName
    );
  }

  mostrarDataText(itemName: string, inputType: string, editable: boolean) {
    let valorrecibido = this.fuenteDinamicaData[itemName];

    if (inputType === 'date' && editable)
      this.localStorageService.dateBackup[itemName] = false;

    if (valorrecibido === null || valorrecibido === undefined) {
      valorrecibido = '-';
    }

    if (typeof valorrecibido === 'object' && valorrecibido !== null) {
      const objectKeys = Object.keys(valorrecibido);
      if (objectKeys.length === 0) {
        return '-';
      }

      try {
        return JSON.stringify(valorrecibido);
      } catch (_error) {
        return objectKeys
          .map((key) => `${key}: ${valorrecibido[key]}`)
          .join(', ');
      }
    }

    return valorrecibido?.toString();
  }

  validaDate(validaDis: boolean = false) {
    const dateVars = Object.getOwnPropertyNames(this.localStorageService.dateBackup);


    if (this.isEditing && dateVars && !validaDis) {
      for (const dateVar of dateVars) {
        let value = this.fuenteDinamicaData[dateVar]?.toString()
        if (value) {
          const valueStruct = this.struct.find(field => field.name === dateVar);
          if (valueStruct) {
            const { pattern } = valueStruct;
            const newValue = this.sharedService.validateFormatDate(pattern, value);
            this.form.controls[dateVar].setValue(newValue)
          }
        }
      }
    } else if (dateVars) {
      for (const dateVar of dateVars) {
        if (this.localStorageService.dateBackup[dateVar] === true)
          this.form.controls[dateVar].setValue(this.fuenteDinamicaData[dateVar]);
      }
    }
  }

  returnToList() {

    this.showList.emit(this.SUB_DOMAIN_JO);
    this.onIsAdding.emit(false);
  }

  reloadList(
    currentMatchKeyOld: string,
    currentMatchKeyNew: string,
    currentCountry: string
  ) {

    this.showReloadList.emit({
      subDomainJO: this.SUB_DOMAIN_JO,
      currentMatchKeyOld: currentMatchKeyOld,
      currentMatchKeyNew: currentMatchKeyNew,
      currentCountry: currentCountry,
    });
  }

  openAddOrUpdateComplete() {
    this.dialog.closeAll();

    this.notificationAlertService.show({
      title: '¡Los cambios se solicitaron correctamente!',
      type: 'success',
      mode: 'component',
      position: 'top-right',
      color: '#fff',
      maxWidth: '960px'
    });
    this.isEditing = false;
    this.emitIsEditing.emit(this.isEditing);
  }

  openUpdateCompleteReloadMatchkey(
    currentMatchKeyOld: string,
    currentMatchKeyNew: string,
    currentCountry: string
  ) {
    this.dialog.closeAll();

    this.notificationAlertService.show({
      title: '¡Los cambios se solicitaron correctamente!',
      type: 'success',
      mode: 'component',
      position: 'top-right',
      color: '#fff',
      maxWidth: '960px'
    });
    this.isEditing = false;
    this.emitIsEditing.emit(this.isEditing);
    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      currentMatchKeyOld = "";
      currentMatchKeyNew = "";
    }
    this.reloadList(currentMatchKeyOld, currentMatchKeyNew, currentCountry);
  }

  formatTimeInput(time) {
    if (this.SUB_DOMAIN_JO === "IMMIGRANT_REGISTER") {
      // TODO: hacer esto dinámico en STRUCT o MENU
      let hour = String(time).slice(0, 2);
      let minute = String(time).slice(-2);
      this.time = hour + ":" + minute;
      return hour + ":" + minute;
    } else {
      return null;
    }
  }

  /**
   * Serializa un objeto a JSON manejando BigInt sin pérdida de precisión.
   * JSON.stringify() no soporta BigInt nativamente, así que lo convertimos manualmente.
   * @param obj - Objeto a serializar que puede contener BigInt
   * @returns String JSON con BigInt convertido a número sin pérdida de precisión
   */
  private serializeBigIntObject(obj: any): string {
    // Reemplazar BigInt por su representación numérica como string sin comillas
    // Esto permite que el JSON tenga el número sin las comillas de string
    const jsonString = JSON.stringify(obj, (key, value) => {
      if (typeof value === 'bigint') {
        // Marcar con un placeholder único que reemplazaremos después
        return `__BIGINT__${value.toString()}__BIGINT__`;
      }
      return value;
    });

    // Reemplazar los placeholders con números sin comillas
    return jsonString.replace(/"__BIGINT__(\d+)__BIGINT__"/g, '$1');
  }

  /**
   * Construye payload DIS desde valores del formulario o datos externos.
   * @param valuesActual - Valores actuales (usado en períodos situation)
   * @param dataviews - Schema Avro de los campos
   * @param externalValues - Valores externos para edición masiva (opcional)
   * @param modifiedFields - Lista de campos modificados para edición masiva (opcional)
   * @param skipDirtyCheck - Omitir verificación de dirty en RDS modify (para edición masiva)
   */
  async dataToSaveDISfromDataview(
    valuesActual?: any,
    dataviews?: Array<any>,
    externalValues?: any,
    modifiedFields?: string[],
    skipDirtyCheck: boolean = false
  ) {

    const valuesChange = externalValues ?? this.form.value;

    const data = [];

    // RDS Interno/Externo - isAdding
    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      if (this.isAdding) {
        this.localStorageService.valorprimaryKeyRDS = "";
        this.localStorageService.setPrimarykeyRds = "";
        let objectRDS: any = {};

        const primaryKeyFieldRD = this.localStorageService.getPrimaryKeyFieldRDS;
        const dataviewArr = dataviews ?? this.localStorageService.getDataview;

        dataviewArr.forEach(element => {
          if (primaryKeyFieldRD !== element.fieldName) {
            let valueCapture = this.returnValueDISDataview(valuesChange, element);
            objectRDS[element.fieldName] = this.sharedService.serializeAvroValue(element.dataType ?? element.type, valueCapture);
          } else {
            let valueCaptureKey = this.returnValueDISDataview(valuesChange, element);
            this.localStorageService.valorprimaryKeyRDS = valueCaptureKey;
            this.localStorageService.setPrimarykeyRds = valueCaptureKey;
          }
        });

        // Para RDS, devolver directamente el objeto sin stringify ni wrapper
        return objectRDS;
      } else {
        // RDS Interno/Externo - Modificación
        let objectRDS: any = {};
        const dataviewArr = dataviews ?? this.localStorageService.getDataview;

        let dirtyControls = {};
        let dirtyFields: string[] = [];

        if (skipDirtyCheck && modifiedFields) {
          // Edición masiva: usar modifiedFields proporcionados
          dirtyFields = modifiedFields;
          modifiedFields.forEach(key => {
            dirtyControls[key] = valuesChange[key];
          });
        } else {
          // Edición individual: usar this.form.controls.dirty
          for (const key in this.form.controls) {
            if (this.form.controls[key].dirty) {
              dirtyControls[key] = this.form.controls[key].value;
            }
          }
          dirtyFields = Object.keys(dirtyControls);
        }

        if (dirtyFields.length === 0) {
          return null;
        }

        dirtyFields.forEach(key => {
          const element = dataviewArr.find(dv => dv.fieldName === key);
          if (element) {
            let valueCapture = this.returnValueDISDataview(dirtyControls, element);
            objectRDS[element.fieldName] = this.sharedService.serializeAvroValue(element.dataType ?? element.type, valueCapture);
          }
        });

        if (Object.keys(objectRDS).length === 0) return null;
        // Para RDS, devolver directamente el objeto sin stringify ni wrapper
        return objectRDS;
      }
    } else { // Lógica para el flujo DIS/GKL
      if (dataviews === undefined || dataviews.length === 0) {
        // this is intencional (mantener compatibilidad con método antiguo)
        return undefined;
      } else {
        let disObject: any = {};

        for (const element of dataviews) {
          let valueCapture: any;
          if (element.name === "keying") {
            let valorRetornoDis: any = "";

            if (this.localStorageService.esAltaEntidades) {
              valorRetornoDis = await this.fuenteDinamicaService.consumeKeyingAddEntity(valuesChange);
            } else {
              // Usar modifiedFields si se proporciona (edición masiva), si no usar this.atributosFuenteModif
              const fieldsModified = modifiedFields ?? this.atributosFuenteModif;
              valorRetornoDis = await this.fuenteDinamicaService.consumeKeying(
                valuesChange,
                fieldsModified,
                this.SUB_DOMAIN_JO,
                this.currentCountry.toUpperCase(),
                this.typeServiceMenu,
                this.isAdding // Pasar isAdding para usar perfil de ingesta si es creación nueva
              );
            }

            // Lógica de períodos para tipo 'situation' (del método antiguo)
            if (this.periods && this.periodsType === 'situation') {
              valorRetornoDis = this.tempPeriodsVariant.contKeying === 0 ?
                await this.fuenteDinamicaService.consumeKeying(
                  valuesActual,
                  this.atributosFuenteModif,
                  this.SUB_DOMAIN_JO,
                  this.currentCountry.toUpperCase(),
                  this.typeServiceMenu,
                  this.isAdding // Pasar isAdding también aquí
                ) :
                this.tempPeriodsVariant.keying;

              if (this.tempPeriodsVariant.contKeying === 0) {
                this.tempPeriodsVariant.keying = valorRetornoDis;
                this.tempPeriodsVariant.contKeying++;
              }
            }

            disObject[element.name] = valorRetornoDis;
          } else {
            if (element.name == "denominacion" && this.SUB_DOMAIN_JO == "NATURAL_PERSON" && this.currentCountry.toUpperCase() == "AR") {
              valueCapture = valuesChange.apellidos + "," + valuesChange.nombres;
            } else {
              valueCapture = this.returnValueDISDataview(valuesChange, element);
            }
            disObject[element.name] = this.sharedService.serializeAvroValue(element.type ?? element.dataType, valueCapture);
          }
        }

        // Serializar manualmente para preservar precisión de BigInt
        // JSON.stringify no soporta BigInt, así que lo convertimos manualmente
        const serializedObject = this.serializeBigIntObject(disObject);
        data.push(serializedObject);
        return { data };
      }
    }
  }

  formatoValue(element, valueCapture): any {
    if (valueCapture === null) {
      return null;
    }

    let type;
    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      type = Array.isArray(element.dataType)
        ? this.optionType(element.dataType.find(x => x !== "null" || null))
        : this.optionType(element.dataType);
      if (type === 'array') {
        const struct = this.struct.find(x => x.name === element.fieldName);
        const { subFields } = struct;
        return this.fuenteDinamicaService.createObjectDISArray(valueCapture, subFields);
      } else { // Mandatorio: Si / Nulleable: No / No opcional // Si es mandatorio, no le puedo mandar null (porque sólo puede tener un tipo de valor)
        return this.sharedService.convertFormatDIS(type, valueCapture);
      }

    } else {
      type = Array.isArray(element.type)
        ? this.optionType(element.type.find(x => x !== "null" || null))
        : this.optionType(element.type);

      if (type === 'array') {
        const struct = this.struct.find(x => x.name === element.name);
        const { subFields } = struct;
        return this.fuenteDinamicaService.createObjectDISArray(valueCapture, subFields);
      } else { // Mandatorio: Si / Nulleable: No / No opcional // Si es mandatorio, no le puedo mandar null (porque sólo puede tener un tipo de valor)
        return this.sharedService.convertFormatDIS(type, valueCapture);
      }
    }
  }

  // funcion que genera el formato de los atributos \"atributo\":\"value\" || "\atributo\":{"\tipo\":"\value\"} en el object que se envia a servicio DIS
  // se ocupa en setAllPeriods()
  formatoValueOld(element, point, valueCapture): string {

    let salidaStr: string = '';

    if (valueCapture === null) {
      if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
        return `"${element.fieldName}":null${point}`;
      } else {
        return `"${element.name}":null${point}`;
      }
    }

    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {

      if (Array.isArray(element.dataType)) {
        let types = element.dataType.find(x => x !== "null" || null);

        let type = this.optionType(types);

        if (type === 'array') {
          const struct = this.struct.find(x => x.name === element.fieldName);
          const { subFields } = struct;
          const valueConvert = this.fuenteDinamicaService.createObjectDISArray(valueCapture, subFields);
          if (valueCapture !== null) {
            salidaStr += `"${element.fieldName}":${JSON.stringify(valueConvert)}${point}`; // TODO: revisar cuando devuelve esto
            // salidaStr += `"${element.fieldName}":`; // TODO: revisar cuando devuelve esto
          } else {
            salidaStr += `"${element.fieldName}":${valueCapture}${point}`;
          }
        } else {
          let valueConvert = this.sharedService.convertFormatDISOld(type, valueCapture);

          salidaStr += valueConvert !== null
            ? `"${element.fieldName}":{"${type}":${valueConvert}}${point}` // Ejemplo: "key": {"string":"000"},
            : `"${element.fieldName}":${valueConvert}${point}`; // Ejemplo: "key": null,
        }
      } else { // Mandatorio: Si / Nulleable: No / No opcional // Si es mandatorio, no le puedo mandar null (porque sólo puede tener un tipo de valor)
        let type = this.optionType(element.dataType);

        if (type === 'array') {
          const struct = this.struct.find(x => x.name === element.fieldName);
          const { subFields } = struct;
          const valueConvert = this.fuenteDinamicaService.createObjectDISArray(valueCapture, subFields);
          if (valueCapture !== null) {
            salidaStr += `"${element.fieldName}":${JSON.stringify(valueConvert)}${point}`; // TODO: revisar cuando devuelve esto
          } else {
            salidaStr += `"${element.fieldName}":${valueCapture}${point}`;
          }
        } else {
          let valueConvert = this.sharedService.convertFormatDISOld(type, valueCapture);

          salidaStr += `"${element.fieldName}":${valueConvert}${point}`; // Ejemplo: "key": "000"
        }
      }

    } else {

      if (Array.isArray(element.type)) { // Mandatorio: No / Nulleable: Si / Opcional // No es mandatorio, puede ser opcional, lo puedo mandar o no
        let types = element.type.find(x => x !== "null" || null);

        let type = this.optionType(types);
        if (type === 'array') {

          /// optener si es mandatorio o no ///
          let mandatory = element.type.some(x => x === "null" || null);

          const struct = this.struct.find(x => x.name === element.name);
          const { subFields } = struct;
          const valueConvert = this.fuenteDinamicaService.createObjectDISArray(valueCapture, subFields);

          if (valueCapture !== null && !mandatory) {
            salidaStr += `"${element.name}":${JSON.stringify(valueConvert)}${point}`;
          } else if (valueCapture !== null && mandatory) {
            salidaStr += `"${element.name}":{${type}:${JSON.stringify(valueConvert)}}${point}`;
          } else {
            salidaStr += `"${element.name}":${valueCapture}${point}`;
          }

        } else {
          let valueConvert = this.sharedService.convertFormatDISOld(type, valueCapture);

          salidaStr += valueConvert !== null
            ? `"${element.name}":{"${type}":${valueConvert}}${point}` // Ejemplo: "key": {"string":"000"},
            : `"${element.name}":${valueConvert}${point}`; // Ejemplo: "key": null,
        }
      } else {
        let type = this.optionType(element.type);

        if (type === 'array') {
          const struct = this.struct.find(x => x.name === element.name);
          const { subFields } = struct;
          const valueConvert = this.fuenteDinamicaService.createObjectDISArray(valueCapture, subFields);
          if (valueCapture !== null) {
            salidaStr += `"${element.name}":${JSON.stringify(valueConvert)}${point}`; // TODO: revisar cuando devuelve esto
          } else {
            salidaStr += `"${element.name}":${valueCapture}${point}`;
          }
        } else {
          let valueConvert = this.sharedService.convertFormatDISOld(type, valueCapture);

          salidaStr += `"${element.name}":${valueConvert}${point}`; // Ejemplo: "key": "000"
        }
      }
    }
    return salidaStr;
  }

  // función que modifica algunos valores del DIS
  //   modifica salidaValue con valores específicos por pais, dominio o subdominio
  returnValueDISDataview(valuesChange: any, element: any) {
    let salidaValue = null;

    // Para campos tipo array NO editables, usar siempre el valor original de la fuente (selectedFuenteDinamica).
    // Razón: cuando el array llega vacío ([]), el form lo rellena con un item fake para mostrar la estructura
    // en la tabla de la UI. Si se leyera el form, ese item fake se enviaría al DIS rompiendo la validación AVRO.
    // Los arrays no editables no pueden ser modificados por el usuario, por lo que el valor original es correcto.
    if (element.type === 'array' && !element.editable) {
      const originalValue = this.selectedFuenteDinamica?.[element.name];
      return originalValue !== undefined ? originalValue : null;
    }

    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {

      if (valuesChange[element.fieldName] !== undefined) {
        salidaValue = valuesChange[element.fieldName];
      } else if (this.selectedFuenteDinamica[element.fieldName] !== undefined) {
        salidaValue = this.selectedFuenteDinamica[element.fieldName];
      }
    } else {

      if (valuesChange[element.name] !== undefined) {     // Prioriza el valor del formulario si está definido
        salidaValue = valuesChange[element.name]; // escape doble del n para string
      } else if (this.selectedFuenteDinamica[element.name] !== undefined) { // Si no está en el formulario, busca en el objeto de la fuente dinámica
        salidaValue = this.selectedFuenteDinamica[element.name]; // escape doble del n para string
      }
      FieldsSourceDIS.forEach((itemCountry: IFieldsSourceDIS) => {

        if (itemCountry.country?.toUpperCase() === this.localStorageService.getSourceCountrySelected) {
          itemCountry.fields?.forEach((item: IFieldFieldsSourceDIS) => {

            if (
              (item.domain?.toUpperCase() === this.localStorageService.getSourceDomainSelected || item.domain === undefined) &&
              (item.subdomain?.toUpperCase() === this.localStorageService.getSourceSubDomainSelected || item.subdomain === undefined) &&
              (item.field?.toUpperCase() === element.name?.toUpperCase())
            ) {
              switch (item.type) {
                case 'text':
                  salidaValue = item.value;
                  break;
                case "user":
                  salidaValue = this.localStorageService.dataLogin.getUser()?.toUpperCase() + " - " + this.localStorageService.dataLogin.getName()?.toUpperCase(); // JPP1 - Juan Perez
                  break;
                case "fuente":
                  salidaValue = (this.localStorageService.getIsVip) ? "VIP" : "DATA MAINTENANCE";
                  break;
                case "current_date":
                  salidaValue = parseInt(this.datesTimesService.getCurrentDate());
                  break;
                case "current_date_time":
                  salidaValue = this.datesTimesService.getCurrentDateTime();
                  break;
                case "current_date_adding":
                  if (this.isAdding) {
                    salidaValue = parseInt(this.datesTimesService.getCurrentDate());
                  }
                  break;
                case "current_date_time_adding":
                  if (this.isAdding) {
                    salidaValue = parseInt(this.datesTimesService.getCurrentDateTime());
                  }
                  break;
                default:
                  break;
              }
            }
          });
        }
      });
    }

    // Para campos tipo map, convertir todos sus values a string al momento de guardar.
    if (this.isMapField(element)) {
      salidaValue = this.normalizeMapValuesAsString(salidaValue);
    }

    return salidaValue;
  }

  private isMapField(element: any): boolean {
    const inputType = String(element?.inputType || '').toLowerCase();
    const type = String(element?.type || '').toLowerCase();
    return inputType === 'map' || type === 'map';
  }

  private normalizeMapValuesAsString(value: any): any {
    if (value === null || value === undefined || value === '') {
      return value;
    }

    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return this.normalizeMapValuesAsString(parsed);
      } catch {
        return value;
      }
    }

    if (typeof value !== 'object' || Array.isArray(value)) {
      return String(value);
    }

    return Object.entries(value).reduce((acc, [key, entryValue]) => {
      if (entryValue === null || entryValue === undefined) {
        acc[key] = '';
      } else if (typeof entryValue === 'object') {
        try {
          acc[key] = JSON.stringify(entryValue);
        } catch {
          acc[key] = String(entryValue);
        }
      } else {
        acc[key] = String(entryValue);
      }
      return acc;
    }, {} as Record<string, string>);
  }

  optionType(val) {
    if (typeof val === "object") {
      return val.type;
    } else {
      return val;
    }
  }

  comparteTempModal() {
    const form = this.form.value;

    if (this.tempModal.name !== "") {
      const valueChange = form[this.tempModal.name];
      if (this.tempModal.value !== valueChange) {
        this.tempModal.state = true;
        this.tempModal.value = valueChange;
      } else {
        this.tempModal.state = false;
      }
    }
  }

  associateField() {
    const form = this.form.value;

    this.struct.forEach(element => {
      let associate = "";
      let value;
      let name = "";
      let val = "";
      let valor: any;
      let da = "";

      // Solo procesar la asociación código-descripción si:
      // 1. El campo tiene associateField definido
      // 2. El campo es de tipo select (tiene variables categóricas)
      if (element.associateField !== null && element.inputType === 'select') {
        name = element.name;

        value = element.value;
        if (form[name]) {
          this.selectedFuenteDinamica[name] = form[name];
          da = form[name];
        } else {
          da = this.selectedFuenteDinamica[name];
        }
        if (value) {


          valor = value.find(x => String(x.value) === String(da));

          if (valor) {
            val = valor.text;
          }

          associate = element.associateField;
          this.selectedFuenteDinamica[associate] = val;
        }
      }
    })
  }

  optionFormatType(val) {
    // this is intencional
  }

  validaRefSelect(itenName: string, valueSelected: number) {
    if (this.localStorageService.selectDirty[itenName] === false)
      this.form.controls[itenName].markAsPristine();

    const finsStructSelect = this.struct.find(
      (struct) => struct.name === itenName
    );
    if (finsStructSelect.children) {
      const findStructChildren: EstructuraDinamicaField = this.struct.find(
        (struct) => struct.name === finsStructSelect.children
      );

      const filter = findStructChildren.value.filter(
        (option) => option.codeRef === valueSelected.toString()
      );
      this.columnsVisible.forEach((colum) => {
        if (colum.name === finsStructSelect.children) {
          colum.value = filter;
          this.form.controls[colum.name].markAsDirty();
          this.form.controls[colum.name].setValue(filter[0]?.value);
        }
      });

      if (findStructChildren.children) {
        this.validaRefSelect(findStructChildren.name, filter[0].value)
      }
    }

    this.changeDependency(itenName);
  }

  inputValidator(event: any) {
    // const name = event.target.name;
    // let type = this.tempArray.type;

    // if (this.tempValidators.name !== name) {
    //   this.tempValidators.name = name;
    //   const dataviews = this.dataviews.find(x => x.name === name);
    //   const t = dataviews.type;

    //   if (Array.isArray(t)) {
    //     type = t.find(x => x !== 'null');
    //   } else if (typeof t === 'object') {
    //     type = t.type
    //   } else {
    //     type = t;
    //   }
    // }
    // this.tempArray.type = type;
    // const typeNumbers = ['int', 'double', 'number', 'integer'];
    // if (typeNumbers.includes(type)) {
    //   const pattern = /^[0-9]*$/;
    //   this.tempValidators.pattern = pattern;
    //   if (!pattern.test(event.target.value)) {
    //     event.target.value = event.target.value.replace(/[^\d]/g, "");
    //   }
    // }

  }

  initPeriods() {
    this.sharedService.getDetailsShared(this.fuenteDinamicaData, this.currentCountry.toUpperCase(), this.domain, this.SUB_DOMAIN_JO, 'periods').subscribe((result: any) => {
      const sour = Object.keys(result.payload)[0];

      const history = result.payload[sour];
      this.periodsSection = 'CRÉDITO';
      //todo: revisar periodsField para que se utiliza
      const findStrucPeriods = this.struct.find((x: any) => x.periodsField === true);
      this.tempPeriods["history"] = history.sort((a, b) => b[findStrucPeriods.name] - a[findStrucPeriods.name]);

      const periodMaxMin = history.reduce((resultado, objeto) => {
        const numero = objeto[findStrucPeriods.name];
        resultado.max = Math.max(resultado.max, numero);
        resultado.min = Math.min(resultado.min, numero);
        return resultado;
      }, { max: -Infinity, min: Infinity })

      //// separo la fecha
      const newHistory = [];
      history.forEach(element => {
        let newHis = element;
        newHis["year"] = String(element[findStrucPeriods.name]).slice(0, 4);
        newHis["month"] = String(element[findStrucPeriods.name]).slice(4, 6);
        newHis["day"] = String(element[findStrucPeriods.name]).slice(-2);
        let active =
          element[findStrucPeriods.name] === this.selectedFuenteDinamica[findStrucPeriods.name] ?
            true :
            false;
        newHis["active"] = active;
        newHistory.push(newHis);
      })
      this.tempPeriods["newHistory"] = newHistory;
      this.tempPeriods["periodsMax"] = periodMaxMin.max;
      this.tempPeriods["periodsMin"] = periodMaxMin.min;
      this.tempPeriods["periodsCurrent"] = periodMaxMin.max;
    });
  }


  previousPeriods() {
    if (this.periodsType === 'situation') {
      const periodo = this.tempPeriods.periodsCurrent;
      const index = this.arrayPeriodosHist.findIndex(periods => String(periods.periodo) === String(periodo));
      const prevIndex = index - 1;
      if (prevIndex > -1) {
        const periodSelect = this.arrayPeriodosHist[prevIndex];
        this.changePeriods = periodSelect;
      }
    } else {
      const index = this.tempPeriods.newHistory.findIndex(x => x.active);
      const prevIndex = index - 1;

      if (prevIndex > -1) {
        this.tempPeriods.newHistory[index].active = false;
        this.tempPeriods.newHistory[prevIndex].active = true;
        const periodsActual = this.tempPeriods.newHistory[prevIndex];
        const arrayPeriodosHist = this.tempPeriods.newHistory;
        const event = { arrayPeriodosHist, periodsActual };
        this.setPeriodsCurrent(event);
      }
    }
  }

  updateNominativo() {
    const { subDomainJO, domainJO } = this.localStorageService.getDataSourceSelected;
    const buscadorSelect = this.localStorageService.getBuscadorSelect;
    const subDomain = buscadorSelect?.subDomain;
    const domain = buscadorSelect?.domain;
    const isHash = !!buscadorSelect?.isHash;

    if (!subDomain || !domain) {
      console.warn('[updateNominativo] No existe buscador seleccionado. Se omite actualización nominativa.');
      return;
    }

    let { cedula, hash, entityKey } = this.localStorageService.getPersonaSelected;

    const paisSeleccionado: string = this.localStorageService.getRegionSeleccionada?.getCode()?.toLowerCase();

    if (subDomainJO === "VEHICLE_APPRAISAL" && paisSeleccionado === "cl") {
      cedula = this.selectedFuenteDinamica['ppu'];
    }

    if (subDomainJO === "ROL_SUMMARY" && paisSeleccionado === "cl") {
      cedula = this.selectedFuenteDinamica['rol'];
    }

    if (cedula == undefined && paisSeleccionado === "ar" && (subDomainJO === "NATURAL_PERSON" || subDomainJO === "LEGAL_ENTITY")) {
      cedula = this.selectedFuenteDinamica['documento_numero'];
    }

    if (cedula == undefined && paisSeleccionado === "py") {
      cedula = this.selectedFuenteDinamica['documento'];
    }

    if (cedula == undefined && paisSeleccionado === "uy") {
      cedula = this.selectedFuenteDinamica['document_id'];
    }

    if (this.localStorageService.esAltaEntidades) {
      cedula = this.localStorageService.getPersonaSelectedDni;
    }
    if (cedula === undefined) {
      cedula = this.localStorageService.getPersonaSelected.dniDoc
    }

    if ((subDomain === subDomainJO) && (domain === domainJO)) {
      this.buscadorService.searchData(cedula).subscribe({
        next: personaUpdate => {
          let keyFuenteXX = Object.keys(personaUpdate.payload)[0];

          const personMap = keyFuenteXX === subDomain ? personaUpdate.payload[keyFuenteXX] : personaUpdate.payload;
          if (personMap) {
            const atributoName = isHash ? 'hash' : 'entityKey';
            if (this.localStorageService.esAltaEntidades && personMap?.length > 0) {
              this.localStorageService.setMatchkeySelected = personMap[0][atributoName];
              this.localStorageService.setPersonaSelected = personMap[0];
              this.openUpdateCompleteReloadMatchkey(
                personMap[0].entityKey,
                personMap[0].entityKey,
                this.currentCountry
              );
              this.localStorageService.esAltaEntidades = false;
            } else if (this.localStorageService.esAltaEntidades && personMap?.length === 0) {
              this.showModalAltaEntidadRetraso();
            } else {
              const persona: Persona = this.handleProfileService.handleObtenerPersonas(personMap, cedula)?.rows?.find(person => person.persona[atributoName] === (isHash ? hash : entityKey) as string)?.persona;
              if (persona != undefined) {
                this.localStorageService.setMatchkeySelected = persona[atributoName];
                this.localStorageService.setPersonaSelected = persona;
              }
            }
          }
        },
        error: _error => {

          if (_error.status === 403) {
            this.notificationService.showError("No tiene autorización para realizar la búsqueda.");
          } else {
            this.notificationService.showError("Solicitud incorrecta o No se encontraron resultados.");
          }
        }
      });
    } else {
      if (subDomainJO == "DATA_SUPPRESSION") {
        this.fuenteDinamicaService.getDataFuenteDinamicaList(
          'NATURAL_PERSON',
          'ar_reference/data_suppression',
          this.currentCountry,
          'hash',
          'AR_REFERENCE/DATA_SUPPRESSION',
          '/api/v4/sources/',
          false,
          '',
          null,
          false
        ).subscribe((result: any[]) => {
          if (result.length >= 1) {
            const data = result[0];
            const ObjectData = Object.keys(data);
            const dataBoolean = [];

            ObjectData.forEach(el => {
              if (typeof data[el] === "boolean") {
                dataBoolean.push(data[el]);
              }
            })
            this.stateBlock = dataBoolean.some(x => x === true);
          } else {
            this.stateBlock = false;
          }
          this.localStorageService.bloqueoNominativo = this.stateBlock;
          this.sharedService.setdataBloqueo(this.stateBlock);
        }, _err => {
          // Error silencioso: este consumo no afecta el flujo principal
        })
      }
    }
  }

  setTempValidatorsConditionals(validators: Array<any>) {
    this.tempValidatorsValues = {
      min: '',
      max: '',
      maxlength: '',
      minlength: ''
    }
    validators.forEach(x => {
      let type = x.type.toLowerCase();
      const today = this.getTodayForDateInput();

      switch (type) {
        case 'min':
          this.tempValidatorsValues.min = x.value;
          break;
        case 'max':
          this.tempValidatorsValues.max = x.value;
          break;
        case 'maxlength':
          this.tempValidatorsValues.maxlength = x.value;
          break;
        case 'minlength':
          this.tempValidatorsValues.minlength = x.value;
          break;
        case 'futuredate':
          this.tempValidatorsValues.min = today;
          break;
        case 'pastdate':
          this.tempValidatorsValues.max = today;
          break;
        case 'default':

          break;
      }
    })
  }

  private getTodayForDateInput(): string {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  getDateMinLimit(tempItem: any): string | null {
    const explicitMin = this.tempValidatorsValues?.min;
    if (explicitMin !== null && explicitMin !== undefined && String(explicitMin) !== '') {
      return String(explicitMin);
    }

    const validators = Array.isArray(tempItem?.validators) ? tempItem.validators : [];
    const hasFutureDate = validators.some((v: any) => String(v?.type || '').toLowerCase() === 'futuredate');
    if (!hasFutureDate) {
      return null;
    }

    const today = this.getTodayForDateInput();
    if (tempItem?.pattern === 'YYYYMM' || tempItem?.pattern === 'YYYY-MM') {
      return today.slice(0, 7);
    }

    return today;
  }

  getDateMaxLimit(tempItem: any): string | null {
    const explicitMax = this.tempValidatorsValues?.max;
    if (explicitMax !== null && explicitMax !== undefined && String(explicitMax) !== '') {
      return String(explicitMax);
    }

    const validators = Array.isArray(tempItem?.validators) ? tempItem.validators : [];
    const hasPastDate = validators.some((v: any) => String(v?.type || '').toLowerCase() === 'pastdate');
    if (!hasPastDate) {
      return null;
    }

    const today = this.getTodayForDateInput();
    if (tempItem?.pattern === 'YYYYMM' || tempItem?.pattern === 'YYYY-MM') {
      return today.slice(0, 7);
    }

    return today;
  }

  private normalizeValidatorPattern(pattern: unknown): string | RegExp {
    if (typeof pattern !== 'string') {
      return pattern as RegExp;
    }

    const normalized = pattern.trim();
    const wrappedRegex = normalized.match(/^\$\$`(.+)`\$\$$/);
    return wrappedRegex ? wrappedRegex[1] : normalized;
  }

  private resolveInputType(field: EstructuraDinamicaField): string {
    const configuredInputType = String(field?.inputType ?? '').trim().toLowerCase();
    if (configuredInputType) {
      if (['number', 'integer', 'int', 'long', 'float', 'double'].includes(configuredInputType)) {
        return 'number';
      }
      if (configuredInputType === 'bool') {
        return 'boolean';
      }
      return configuredInputType;
    }

    const rawType = Array.isArray(field?.type)
      ? field.type.find((t: any) => t !== 'null')
      : field?.type;
    const parsedType = typeof rawType === 'object'
      ? String(rawType?.type ?? '').toLowerCase()
      : String(rawType ?? '').toLowerCase();

    if (['int', 'integer', 'long', 'float', 'double', 'number'].includes(parsedType)) {
      return 'number';
    }
    if (['boolean', 'bool'].includes(parsedType)) {
      return 'boolean';
    }
    if (['date', 'time', 'select', 'checkbox', 'textarea', 'map', 'array', 'email', 'template'].includes(parsedType)) {
      return parsedType;
    }

    return 'text';
  }

  encodePIIvalues() {
    this.struct.forEach(struct => {
      if (struct?.hash) {
        const valueToEnconde = this.selectedFuenteDinamica[struct.name];
        if (valueToEnconde !== null) {
          if (valueToEnconde !== undefined) {
            this.buscadorService.getEncodeMkService(valueToEnconde).subscribe({
              next: (hashData: { hash: string }) => {
                this.selectedFuenteDinamica[struct.name] = hashData.hash;
              },
              error: (err) => {
                console.error(err);
                this.notificationService.showError('Problema en la encriptación de datos');
              }
            })
          }
        }
      }
    })
  }

  initValueDateYearMonth(name: string) {
    const value = String(this.fuenteDinamicaData[name]);
    const val = value.length === 6 ? `${value.slice(0, 4)}-${value.slice(-2)}` : "";
    this.fuenteDinamicaData[name] = val;
    this.selectedFuenteDinamica[name] = val;
  }

  initStructPeriodsSituation(type: string, data: any, typeInit: boolean) {
    this.struct = [];
    this.SUB_DOMAIN_JO = type;
    this.tempPeriodsTypeSituacion = type;


    const manualVariants = this.localStorageService.getManualVariants;
    const { method, params, matrizValueDefault, section } = manualVariants;
    this.periodsSection = section;


    let title = "";
    method.forEach(element => {

      if (element.type.includes(type)) {
        this.tempPeriodsTitleMethod = element.title;

        title = element.title;
        const addFields = element.addFields;

        let resSituation = [];
        if (addFields.length > 0) {
          addFields.forEach(fields => {
            if (fields.name === params) {
              resSituation = fields.value ? fields.value : [];
            }
          })
          const struct = addFields.map(el => new EstructuraDinamicaField().deserialize(el));
          this.struct = struct;
        }

        const situation = element.situation && element.situation.length > 0 ? element.situation : resSituation;
        const fieldsNoEdit = this.struct.filter(field => !field.editable);

        this.tempPeriodsVariant = {
          params,
          matrizValueDefault,
          type,
          originalHistoric: [],
          currentObject: [],
          title: element.title,
          code: element.code,
          situation,
          fieldsNoEdit,
          contKeying: this.tempPeriodsVariant.contKeying && this.tempPeriodsVariant.contKeying > 0 ? this.tempPeriodsVariant.contKeying : 0,
          keying: this.tempPeriodsVariant.keying ? this.tempPeriodsVariant.keying : ""
        }
      }
    })


    const index = this.struct.findIndex(obj => obj.name === manualVariants.params);

    if (index !== -1) {

      this.struct[index].inputType = "select";
      this.struct[index].value = this.tempPeriodsVariant.situation
    }
    this.sharedService.getDetailsManuals(this.fuenteDinamicaData, this.currentCountry.toUpperCase(), this.domain, this.SUB_DOMAIN_JO, 'periods').subscribe((result: any) => {

      this.currentObject = result.payload[type];
      this.tempPeriodsVariant.currentObject = this.currentObject;

      const originalHistoric = result.payload;
      this.originalHistoric = originalHistoric
      this.tempPeriodsVariant.originalHistoric = originalHistoric;

      this.calculateFirstAndLastItem(this.currentObject);


      this.initDataDefault(data, matrizValueDefault, typeInit);
      this.saberPeriodoMayorInformado();
    })

    const buttonEvent = {
      add: false,
      edit: false
    }

    this.disabledButton.emit(buttonEvent);
    this.setSubTitle.emit(title);
  }

  calculateFirstAndLastItem(periodArray: any) {

    let lastPeriod: any = { "periodo": 0 }
    let firstPeriod: any = { "periodo": 205012 }


    periodArray.forEach(item => {
      if (this.itemPeriodo(lastPeriod.periodo) < this.itemPeriodo(item.periodo)) {
        lastPeriod = item;
      }
      if (this.itemPeriodo(firstPeriod.periodo) > this.itemPeriodo(item.periodo)) {
        firstPeriod = item;
      }
    });

    periodArray['lastPeriod'] = lastPeriod
    periodArray['firstPeriod'] = firstPeriod
    periodArray['tipo'] = this.tempPeriodsTypeSituacion;
    this.currentObject = periodArray;
  }


  setAllPeriods(event) {
    const valueEdit = event;
    const data = [];

    valueEdit.forEach(values => {
      let salidaStr = "{";
      this.dataviews.forEach((element, i: number) => {
        let point = this.dataviews.length === i + 1 ? "" : ",";
        if (element.name === "keying") {
          let valorRetornoDis = "";

          valorRetornoDis = this.tempPeriodsVariant.contKeying === 0 ?
            this.fuenteDinamicaService.consumeKeying(values, this.atributosFuenteModif, this.SUB_DOMAIN_JO, this.currentCountry.toUpperCase(), this.typeServiceMenu, this.isAdding) :
            this.tempPeriodsVariant.keying;

          if (this.tempPeriodsVariant.contKeying === 0) {
            this.tempPeriodsVariant.keying = valorRetornoDis;
            this.tempPeriodsVariant.contKeying++;
          }

          salidaStr += `"${element.name}":${JSON.stringify(valorRetornoDis)}${point}`;
        } else {
          let valueCapture = this.returnValueDISDataview(values, element);
          salidaStr += this.formatoValueOld(element, point, valueCapture);
        }
      });
      salidaStr += "}"
      data.push(salidaStr);
    })

    const source = `${this.domain}/${this.SUB_DOMAIN_JO}`;

    let objectDis = {
      data: []
    }
    objectDis['data'].push(JSON.stringify(data));

    this.fuenteDinamicaService.updateDis(source, this.form, data, 'gkl').subscribe({
      next: _res => {

        this.initStructPeriodsSituation(this.SUB_DOMAIN_JO, this.fuenteDinamicaData, true);
      },
      error: _error => {

      },
    });
  }

  initDataDefault(fuenteDinamicaData, matrizValueDefault, typeInit: boolean) {
    if (typeInit) {
      this.onEdit();
      this.isAdding && this.returnToList();
    }
  }

  saberPeriodoMayorInformado() {
    this.arrayPeriodosHist = [];
    let aniomayor = this.itemPeriodo(this.currentObject['lastPeriod'].periodo).toString().substring(0, 4);
    let mesmayor = this.itemPeriodo(this.currentObject['lastPeriod'].periodo).toString().substring(4, 6);
    this.ultimoPeriodoInformado = aniomayor + mesmayor

    const fecha = new Date();
    let anioactual = fecha.getFullYear();
    let mesactual = fecha.getMonth() + 1;

    let temMesActual = ""
    if (mesactual < 10) {
      temMesActual = "0" + mesactual
    } else {
      temMesActual = String(mesactual)
    }
    let tempActualPeriod = String(anioactual) + String(temMesActual);
    let tempActualPeriodYear = String(anioactual);
    let tempActualPeriodMonth = String(mesactual);

    for (let i = 0; i < 60; i++) {
      const found = this.originalHistoric[this.currentObject.tipo].find(
        element => (
          this.itemPeriodo(element.periodo) == tempActualPeriod
        )
      );
      // create empty or full period
      if (found == undefined) {
        this.itemSituaciones.mes = tempActualPeriodMonth
        this.itemSituaciones.anio = tempActualPeriodYear
        this.itemSituaciones.situacion = '';
        this.itemSituaciones.fecha = '-';
        this.itemSituaciones.mesnum = Number(tempActualPeriodMonth);
        this.itemSituaciones.editable = 'N';
        this.itemSituaciones.situacion_new = '';
        this.itemSituaciones.codigo = '-';
        this.itemSituaciones.matchKey = '-';
        this.itemSituaciones.rowKey = '-';
        this.itemSituaciones.iup = '-';
        this.itemSituaciones.periodo = tempActualPeriodYear + tempActualPeriodMonth;
      } else {
        this.itemSituaciones.mes = this.itemPeriodo(found.periodo).toString().substring(4, 6);
        this.itemSituaciones.anio = this.itemPeriodo(found.periodo).toString().substring(0, 4);
        this.itemSituaciones.situacion = found.situacion_cod;
        this.itemSituaciones.fecha = this.itemPeriodo(found.periodo);
        this.itemSituaciones.mesnum = Number(found.periodo.toString().substring(4, 6));
        this.itemSituaciones.editable = 'S';
        this.itemSituaciones.situacion_new = found.situacion_cod;
        this.itemSituaciones.codigo = found.adh_sector_cod == null || found.adh_sector_cod == "" ? "-" : found.adh_sector_cod;
        this.itemSituaciones.matchKey = found.matchKey;
        this.itemSituaciones.rowKey = found.rowKey;
        this.itemSituaciones.iup = found.iup;
        this.itemSituaciones.periodo = this.itemPeriodo(found.periodo);
      }
      this.arrayPeriodosHist.push(this.itemSituaciones);

      this.itemSituaciones = {
        mes: null,
        anio: null,
        situacion: null,
        fecha: null,
        mesnum: null,
        editable: null,
        situacion_new: null,
        codigo: null,
        matchKey: null,
        rowKey: null,
        iup: null,
        periodo: null
      };
      tempActualPeriodMonth = String(Number(tempActualPeriodMonth) - 1)
      if (parseInt(tempActualPeriodMonth) == 0) {
        tempActualPeriodMonth = String(12)
        tempActualPeriodYear = String(parseInt(tempActualPeriodYear) - 1)
      }
      if (String(tempActualPeriodMonth).length < 2) {
        tempActualPeriodMonth = "0" + tempActualPeriodMonth;
      }

      tempActualPeriod = tempActualPeriodYear + tempActualPeriodMonth;
    }

  }

  itemPeriodo(oldPeriodo: any) {
    let newPeriodo = oldPeriodo;
    if (String(oldPeriodo).length === 8) {
      if (typeof oldPeriodo === "string") {
        newPeriodo = String(oldPeriodo).slice(0, -2);
      } else if (typeof oldPeriodo === "number") {
        newPeriodo = Number(String(oldPeriodo).slice(0, -2));
      }
    }
    return newPeriodo;
  }

  setPeriodsCurrent(event: any) {
    const { periodsActual } = event;

    const keyData = Object.keys(this.fuenteDinamicaData);
    const value = this.form.value;

    let setForm = {}
    this.struct.forEach(element => {
      if (element.editable) {
        setForm[element.name] = periodsActual[element.name];
      }
    });

    keyData.forEach(x => {
      this.fuenteDinamicaData[x] = periodsActual[x];
      this.selectedFuenteDinamica[x] = periodsActual[x];
    })

    this.selectedFuenteDinamica['matchKey'] = periodsActual["matchKey"];
    setForm["matchKey"] = periodsActual["matchKey"];
    setForm["row"] = null;
    this.form.patchValue(setForm);
    if (periodsActual.periodo) {
      this.tempPeriods["periodsCurrent"] = periodsActual.periodo;
    }

    const eventButtonAdd = event.type === "add" ? true : false;
    const eventButtonEdit = event.type === "edit" ? true : false;

    const buttonEvent = {
      add: eventButtonAdd,
      edit: eventButtonEdit
    }
    //const
    this.disabledButton.emit(buttonEvent);
  }

  nextPeriods() {
    if (this.periodsType === 'situation') {
      const periodo = this.tempPeriods.periodsCurrent;
      const index = this.arrayPeriodosHist.findIndex(periods => String(periods.periodo) === String(periodo));
      const nextIndex = index + 1;
      if (index !== -1 && (nextIndex < this.arrayPeriodosHist.length)) {
        const periodSelect = this.arrayPeriodosHist[nextIndex];
        this.changePeriods = periodSelect;
      }
    } else {
      const index = this.tempPeriods.newHistory.findIndex(x => x.active);
      const nextIndex = index + 1;
      if (nextIndex < this.tempPeriods.newHistory.length) {
        this.tempPeriods.newHistory[index].active = false;
        this.tempPeriods.newHistory[nextIndex].active = true;
        const periodsActual = this.tempPeriods.newHistory[nextIndex];
        const arrayPeriodosHist = this.tempPeriods.newHistory;
        const event = { arrayPeriodosHist, periodsActual };
        this.setPeriodsCurrent(event);

      }
    }
  }

  setSituation(event) {
    const { params, value } = event;
    this.form.get(params).setValue(value);
  }

  showModalAltaEntidadRetraso() {
    this.showModal = true;
    this.tituloModal = 'Registro en Proceso';
    this.bodyModal = `Su registro <strong>se encuentra en proceso</strong>. <br>
    Por favor, vuelva a consultar su número en unos minutos. <br>
    Agradecemos su paciencia mientras finalizamos la creación de su solicitud.`;
  }

  changeDependency(name: string) {

    this.struct.forEach(field => {
      if (field.name === name) {
        if (field.dependency && field.dependency.length > 0) {

          let valueForm = this.form.get(name)?.value;

          field.dependency.forEach(depend => {
            let { params, depends, type, value } = depend;
            const control = this.form.get(params)

            value = type === 'date' ?
              this.datesTimesService.getCurrentDate()
              : type === 'user' ? this.localStorageService.dataLogin.getUser()?.toUpperCase() + " - " + this.localStorageService.dataLogin.getName()?.toUpperCase()
                : value;
            if (control) {
              if (String(depends.toLowerCase()) === String(valueForm.toLowerCase())) {
                control.setValue(value);
              }
            } else {
              if (String(depends.toLowerCase()) === String(valueForm.toLowerCase())) {
                this.fuenteDinamicaData[params] = value;
              }
            }
          })
        }
      }
    })
  }

  // Configuración centralizada - todos los números en un solo lugar
  private readonly TEXT_CONFIG = [
    { minLength: 115, colSize: 12 },
    { minLength: 80, colSize: 9 },
    { minLength: 45, colSize: 6 },
    { minLength: 0, colSize: 3 }
  ] as const;

  private getTextCategory(length: number): number {
    // Encuentra la primera configuración que cumple con el mínimo
    const config = this.TEXT_CONFIG.find(cfg => length >= cfg.minLength);
    return this.TEXT_CONFIG.indexOf(config!);
  }

  getColumnClass(tempItem: any): string {
    const type = tempItem.inputType;
    const values = tempItem.value;

    if (type === 'textarea' || type === 'array' || type === 'map') {
      return 'col-lg-12';
    }

    if (!Array.isArray(values) || values.length === 0) {
      return 'col-lg-3';
    }

    const maxLength = Math.max(...values.map(v => v.text?.length || 0));
    const categoryIndex = this.getTextCategory(maxLength);

    return `col-lg-${this.TEXT_CONFIG[categoryIndex].colSize}`;
  }

  // Cache de options por campo: [options] se re-evalúa en CADA ciclo de detección
  // de cambios porque está bindeado a una función en el template. Si esa función
  // devuelve un array NUEVO cada vez, efx-dropdown dispara ngOnChanges en cada CD
  // (incluso mientras el usuario escribe en el buscador), y su propio ngOnChanges
  // hace `this.searchResults = changes.options.currentValue` cuando isSearchable
  // es true, pisando el resultado ya filtrado por searchByType(). Por eso el filtro
  // "no funcionaba": se resetea a la lista completa apenas corre el próximo CD.
  // Cacheamos por nombre de campo y solo recalculamos si la fuente (value/template
  // options) realmente cambió de referencia.
  private dropdownOptionsCache = new Map<string, { sourceRef: any; options: Array<{ id: any; description: string; disabled?: boolean }> }>();

  getDropdownOptions(tempItem: any): Array<{ id: any; description: string; disabled?: boolean }> {
    const cacheKey = tempItem?.name;
    const isTemplate = tempItem?.inputType === 'template';
    const sourceRef = isTemplate ? this.tempTemplate?.[tempItem.name]?.option : tempItem?.value;

    const cached = this.dropdownOptionsCache.get(cacheKey);
    if (cached && cached.sourceRef === sourceRef) {
      return cached.options;
    }

    // eslint-disable-next-line no-console
    let options: Array<{ id: any; description: string; disabled?: boolean }>;
    if (isTemplate) {
      const templateOptions = sourceRef || [];
      options = templateOptions.map((option: string) => ({
        id: option,
        description: option,
        disabled: false,
      }));
    } else {
      const values = Array.isArray(sourceRef) ? sourceRef : [];
      const dependencyDescMap = this.buildDependencyDescMap(tempItem);
      options = values.map((valueItem: any) => {
        const codeValue = valueItem?.value === null || valueItem?.value === undefined
          ? ''
          : String(valueItem.value);
        // Variables categóricas: cuando "text" no trae una descripción real (viene igual al
        // código, ej. {text:"S", value:"S"}), la descripción real vive en "dependency"
        // (depends -> value), sin importar a qué campo ("params") apunte esa dependencia.
        const text = dependencyDescMap.has(codeValue) ? dependencyDescMap.get(codeValue) : valueItem?.text;
        return {
          id: codeValue,
          description: this.showCodeDescInSelect(valueItem?.value, text),
          disabled: false,
        };
      });
    }

    this.syncMultiSelectOptionsState(tempItem, options);
    this.dropdownOptionsCache.set(cacheKey, { sourceRef, options });
    return options;
  }

  private buildDependencyDescMap(tempItem: any): Map<string, string> {
    const map = new Map<string, string>();
    const dependencies = tempItem?.dependency;
    if (!Array.isArray(dependencies)) return map;

    dependencies.forEach((dep: any) => {
      if (dep?.type === 'other') {
        const code = dep?.depends === null || dep?.depends === undefined ? '' : String(dep.depends);
        map.set(code, dep.value);
      }
    });
    return map;
  }

  // Sincroniza option.selected solo cuando se construyen opciones o cuando ya cambió
  // el valor del multiselect. No debe correrse en cada getter cacheado porque muta
  // el mismo array que está renderizando efx-checkbox-multi-list.
  private syncMultiSelectOptionsState(tempItem: any, options: Array<{ id: any; description: string; disabled?: boolean; selected?: boolean }>): void {
    if (!tempItem?.isMultiSelect) {
      return;
    }
    const rawValue = this.form?.get(tempItem?.name)?.value;
    const selectedIds = new Set((Array.isArray(rawValue) ? rawValue : []).map((v: any) => String(v)));
    options.forEach((option) => {
      option.selected = selectedIds.has(String(option.id));
    });
  }

  getDropdownSelectedId(tempItem: any): any {
    if (tempItem?.isMultiSelect) {
      return undefined;
    }
    const value = this.form?.get(tempItem?.name)?.value;
    if (value === null || value === undefined) {
      return value;
    }
    // Boolean values need string coercion to match option ids like 'true'/'false'
    if (typeof value === 'boolean') {
      return String(value);
    }
    return String(value);
  }

  isDropdownInvalid(tempItem: any): boolean {
    const control = this.form?.get(tempItem?.name);
    const value = control?.value;
    const isTouched = !!(control?.dirty || control?.touched);
    const requiredAndEmpty = tempItem?.nullable === false
      && (value === null || value === undefined || value === '');

    return isTouched && (requiredAndEmpty || !!control?.invalid);
  }

  onDynamicDropdownChange(tempItem: any, eventValue: any): void {
    const selectedValue = eventValue && typeof eventValue === 'object' && 'id' in eventValue
      ? eventValue.id
      : eventValue;

    // eslint-disable-next-line no-console
    if (tempItem?.inputType === 'template') {
      this.changeTemplate({
        target: {
          name: tempItem.name,
          value: selectedValue,
        },
      });
      return;
    }

    this.validaRefSelect(tempItem.name, selectedValue as any);
  }

  onDynamicDropdownMultiChange(tempItem: any, selectedIds: string[]): void {
    const control = this.form?.get(tempItem?.name);
    if (!control) {
      return;
    }
    control.setValue(selectedIds ?? []);
    control.markAsDirty();
    control.markAsTouched();
    const cached = this.dropdownOptionsCache.get(tempItem?.name);
    if (cached) {
      this.syncMultiSelectOptionsState(tempItem, cached.options);
    }
    this.changeDependency(tempItem.name);
    // efx-dropdown reconstruye selectedItems con el texto completo al hacer click;
    // se vuelve a truncar para los pills tras aplicar el cambio.
    queueMicrotask(() => this.refreshMultiSelectPills());
  }

  // Reconstruye el valor de cada form control multiselect a partir de option.selected
  // (lo que realmente está tildado en el dropdown). Necesario porque efx-dropdown
  // resetea el form control a undefined en su ngOnChanges, dejando el valor solo en
  // las opciones. Sin emitEvent para no re-disparar dependencias ni marcar dirty extra.
  private syncMultiSelectFormValuesFromOptions(): void {
    (this.struct || []).forEach((field: any) => {
      if (!field?.isMultiSelect) {
        return;
      }
      const control = this.form?.get(field.name);
      const cached = this.dropdownOptionsCache.get(field.name);
      if (!control || !cached) {
        return;
      }
      const selectedIds = cached.options
        .filter((option: any) => option.selected)
        .map((option: any) => option.id);
      control.setValue(selectedIds, { emitEvent: false });
    });
  }

  // Reduce un string según su longitud con un margen adicional para el truncado
  // reducirTexto(texto: string): string {
  //   if (!texto) return texto;

  //   const categoryIndex = this.getTextCategory(texto.length);
  //   const limit = this.TEXT_CONFIG[categoryIndex].minLength;

  //   // No truncar si es la categoría más pequeña (índice 3)
  //   return categoryIndex < this.TEXT_CONFIG.length - 1 && texto.length > limit
  //     ? texto.substring(0, limit) + '...'
  //     : texto;
  // }

  getMapDisplayValue(name: string): string {
    const value = this.form.get(name)?.value ?? this.fuenteDinamicaData?.[name];
    if (value === null || value === undefined) return '';
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value, null, 2);
      } catch {
        return String(value);
      }
    }
    return String(value);
  }

  getMapEditorControls(name: string): FormGroup[] {
    return this.getMapEditor(name).controls as FormGroup[];
  }

  addMapEntry(name: string): void {
    this.getMapEditor(name).push(this.createMapEntryGroup());
    this.syncMapControl(name);
  }

  removeMapEntry(name: string, index: number): void {
    const editor = this.getMapEditor(name);
    editor.removeAt(index);

    if (editor.length === 0) {
      editor.push(this.createMapEntryGroup());
    }

    this.syncMapControl(name);
  }


  syncMapControl(name: string): void {
    const editor = this.getMapEditor(name);
    const control = this.form.get(name);

    if (!control) {
      return;
    }

    const nextValue: Record<string, unknown> = {};
    const seenKeys = new Set<string>();
    let hasEntries = false;
    let hasInvalidEntries = false;

    editor.controls.forEach((group) => {
      const keyRaw = String(group.get('key')?.value ?? '').trim();
      const valueRaw = group.get('value')?.value;
      const hasValue = String(valueRaw ?? '').trim() !== '';

      if (!keyRaw && !hasValue) {
        return;
      }

      if (!keyRaw || seenKeys.has(keyRaw)) {
        hasInvalidEntries = true;
        return;
      }

      seenKeys.add(keyRaw);
      nextValue[keyRaw] = this.parseMapEditorValue(valueRaw);
      hasEntries = true;
    });

    control.setValue(hasEntries ? nextValue : null, { emitEvent: false });
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });

    const currentErrors = { ...(control.errors || {}) } as Record<string, unknown>;
    delete currentErrors['invalidMapJson'];

    if (hasInvalidEntries) {
      currentErrors['invalidMapEntries'] = true;
    } else {
      delete currentErrors['invalidMapEntries'];
    }

    control.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
    this.fuenteDinamicaData[name] = hasEntries ? nextValue as any : null;
    this.form.markAsDirty();
  }

  getMapEntries(name: string, preferForm: boolean = false): Array<{ key: string; value: string }> {
    const sourceValue = preferForm
      ? (this.form.get(name)?.value ?? this.fuenteDinamicaData?.[name])
      : (this.fuenteDinamicaData?.[name] ?? this.form.get(name)?.value);

    try {
      const parsed = this.parseMapValue(sourceValue);
      if (!parsed) {
        return [];
      }

      return Object.entries(parsed).map(([key, entryValue]) => ({
        key,
        value: this.formatMapEntryValue(entryValue)
      }));
    } catch {
      return [];
    }
  }

  getMapEntriesCount(name: string, preferForm: boolean = false): number {
    return this.getMapEntries(name, preferForm).length;
  }

  private parseMapValue(value: unknown): Record<string, unknown> | null {
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        throw new Error('Map inválido: no se permiten arrays');
      }
      return value as Record<string, unknown>;
    }

    const trimmed = String(value).trim();
    if (!trimmed) {
      return null;
    }

    const parsed = JSON.parse(trimmed);
    if (parsed === null) {
      return null;
    }

    if (typeof parsed !== 'object' || Array.isArray(parsed)) {
      throw new Error('Map inválido: se esperaba objeto JSON');
    }

    return parsed as Record<string, unknown>;
  }

  private formatMapEntryValue(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    return String(value);
  }

  private getMapEditor(name: string): FormArray {
    if (!this.mapEditors[name]) {
      const entries = this.getMapEntries(name, true);
      const groups = entries.length
        ? entries.map((entry) => this.createMapEntryGroup(entry.key, entry.value))
        : [this.createMapEntryGroup()];

      this.mapEditors[name] = this.fb.array(groups);
    }

    return this.mapEditors[name];
  }

  private createMapEntryGroup(key: string = '', value: unknown = ''): FormGroup {
    return this.fb.group({
      key: [key],
      value: [this.formatMapEditorControlValue(value)]
    });
  }

  private formatMapEditorControlValue(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    return String(value);
  }

  private parseMapEditorValue(value: unknown): unknown {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value !== 'string') {
      return value;
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return '';
    }

    try {
      return JSON.parse(trimmed);
    } catch {
      return value;
    }
  }

  onMapChange(event: Event, name: string): void {
    const raw = (event.target as HTMLTextAreaElement).value;
    try {
      const parsed = JSON.parse(raw);
      this.form.get(name)?.setValue(parsed);
      this.form.get(name)?.markAsDirty();
    } catch {
      // JSON inválido — no actualizar el control hasta que sea válido
    }
  }

  // tempItem.validators && tempItem.validators.length > 0
  showValidatorsInitial(tempItem: any) {

    let returnShowValidatorsInitial = tempItem.validators &&
      tempItem.validators.length > 0;

    return returnShowValidatorsInitial;
  }

  // Borde rojo y mensaje solo despues de que el usuario toque el campo
  // (dirty o touched), no apenas se abre el formulario de alta.
  showInvalidBorder(form: any, tempItem: any): boolean {
    const control = form.get(tempItem?.name);
    return !!control?.invalid && !!(control?.dirty || control?.touched);
  }

  showValidators(form: any, tempItem: any, error: any) {
    const errorType = String(error?.type || '').toLowerCase();
    const mappedErrorKey = errorType === 'pastdate'
      ? 'pastDate'
      : errorType === 'futuredate'
        ? 'futureDate'
        : errorType;

    const control = form.get(tempItem.name);
    const isTouched = !!(control?.dirty || control?.touched);
    const returnShowValidators = isTouched && control?.errors?.[mappedErrorKey] !== undefined;

    return returnShowValidators;
  }

  isFieldEditable(isEditing, isAdding, tempItem) {
    return (isEditing || isAdding) && tempItem.editable
  }

  generateContribution(accessToken, bodyContribution) {
    const { supplierId, contributionName, contributionData } = bodyContribution;
    this.contributionService.generateContribution(accessToken, bodyContribution).subscribe({
      next: (response: any) => {
        const {
          idContribution,
        } = response;
        const usuario = this.localStorageService.dataLogin.getUser();

        const currentDate: Date = new Date();
        const date = currentDate.toISOString();
        const bodyPersisten = {
          date,
          supplierId,
          idContribution: String(idContribution),
          contributionName,
          user: usuario,
          contributionData,
          phase: "Pendiente de procesamiento"
        }
        this.generartePersistence(bodyPersisten);
        this.showCustom('success', '¡La contribución se solicitó correctamente!');
        this.isEditing = false;
        this.isAdding = false;
        this.emitIsEditing.emit(false);
        this.notificationService
          .showSuccess("¡La contribución se solicitó correctamente!")
          .afterDismissed()
          .subscribe(() => {
            this.returnToList();
          });

      },
      error: (e) => {
        this.showCustom('error', '¡Error al generar contribución!');
      }
    })
  }

  generartePersistence(bodyPersisten) {
    this.contributionService.postPersistenceContribution(bodyPersisten).subscribe({
      next: (response: any) => {
        console.log("generartePersistence response---->", response);
      }, error: (e) => {

      }
    })
  }

  contribution(country) {
    const formData = {};
    const formValues = this.form.value;

    this.struct.forEach(field => {
      if (formValues.hasOwnProperty(field.name)) {
        formData[field.name] = formValues[field.name] ?? "";
      } else {
        formData[field.name] = this.selectedFuenteDinamica[field.name] ?? "";
      }
    });


    const currentDate: Date = new Date();
    const periodo = this.datePipe.transform(currentDate, 'dd-MM-yyyy');
    let supplierId = "";
    let contributionName = "";

    this.confirmationDialogService
      .confirmAction('Contribución', 'Los datos aportados quedan sujetos a revisión de Equifax Uruguay SA, por favor revise periódicamente el Portal de Aportantes, para la confirmación del ingreso de la información.')
      .then((confirmed) => {
        if (confirmed) {
          this.contributionService.generateSessionContribution().subscribe({
            next: (responseT: any) => {
              const accessToken = responseT["access_token"];
              localStorage.setItem('tokenAPIGEE', accessToken || '');
              //const contributionUniversal = this.localStorageService.universalSupplier || "";
              const supliersInformation = this.localStorageService.supliersInformation;
              let t1, t2;
              if (supliersInformation) {
                if (supliersInformation.hasOwnProperty("t1") || supliersInformation.hasOwnProperty("t2")) {
                  t1 = supliersInformation['t1'];
                  t2 = supliersInformation['t2'];

                  supplierId = t1?.supplierId;

                  const profile = this.localStorageService.getBuscadorSelect?.profile || 'CONSUMER';
                  if (t2.length > 0) {
                    const contributionPro = profile === "CONSUMER" ? "PERSONA_INCUMPLIMIENTOS" : "EMPRESA_INCUMPLIMIENTOS";
                    const contribionInformation = t2.find(contribution =>
                      contribution.domain === this.domain
                      && contribution.subdomain === this.SUB_DOMAIN_JO
                      && contribution.contribution === contributionPro
                    );

                    contributionName = profile === "CONSUMER" ?
                      "CREDIT_DEFAULT_INC_PERSONA_INCUMPLIMIENTOS_CSV"
                      : "CREDIT_DEFAULT_INC_EMPRESA_INCUMPLIMIENTOS_CSV";

                    // if (contribionInformation) {
                    //   contributionName = profile === "CONSUMER" ?
                    //     "CREDIT_DEFAULT_INC_PERSONA_INCUMPLIMIENTOS_CSV"
                    //     : "CREDIT_DEFAULT_INC_EMPRESA_INCUMPLIMIENTOS_CSV";
                    // }
                  }
                  const bodyContribution = this.contributionService.generateBodyContribution(
                    formData,
                    supplierId,
                    contributionName,
                    periodo,
                    country,
                    profile
                  );

                  this.generateContribution(accessToken, bodyContribution);
                }
              }

            },
            error: (e) => { }
          })
        }
      })
  }

  showCustom(type: any, title: string, description?: string): void {
    this.notificationAlertService.show({
      title,
      type,
      mode: 'component',
      position: 'top-right',
      color: '#fff',
      maxWidth: '960px'
    });
  }

  autoCompleteContribution(element, country) {
    const name = element?.name;

    const supliersInformation = this.localStorageService.supliersInformation;
    let data: any = this.localStorageService.getPersonaSelected;
    const profile = this.localStorageService.getBuscadorSelect?.profile;
    const isConsumer = profile === 'CONSUMER'; // persona física
    const isCompany = profile === 'COMMERCIAL'; // empresa (el buscador usa 'COMMERCIAL', no 'COMPANY')

    if (name === 'afiliado') {
      const codAfiliado = supliersInformation?.t1["codAfiliado"];
      this.selectedFuenteDinamica[name] = codAfiliado;
      this.fuenteDinamicaData[name] = codAfiliado;
    }

    if (name === 'sucursal') {
      const codSucursal = supliersInformation?.t1["codSucursal"];
      this.selectedFuenteDinamica[name] = codSucursal;
      this.fuenteDinamicaData[name] = codSucursal;
    }

    if (name === 'numero_documento' || name === 'rut') {
      const documento = data?.["rut"] || data?.["identificador"];
      this.selectedFuenteDinamica[name] = documento;
      this.fuenteDinamicaData[name] = documento;
    }

    if (name === 'pais_documento') {
      this.selectedFuenteDinamica[name] = country;
      this.fuenteDinamicaData[name] = country;
    }

    if ((name === 'primer_nombre' || name === 'primer_apellido') && isConsumer) {
      const fullName = data?.['denominacion'];
      let firstName = "";
      let lastName = "";
      if (fullName) {
        const fullNameSplit = fullName.split(" ");

        if (fullNameSplit.length === 4) {
          firstName = fullNameSplit[2];
          lastName = fullNameSplit[0];
        } else if (fullNameSplit.length === 3) {
          firstName = fullNameSplit[1];
          lastName = fullNameSplit[0];
        } else if (fullNameSplit.length === 2) {
          firstName = fullNameSplit[0];
          lastName = fullNameSplit[0];
        } else if (fullNameSplit.length === 1) {
          firstName = fullNameSplit[0];
          lastName = '';
        }
      }

      if (name === 'primer_nombre') {
        this.selectedFuenteDinamica[name] = firstName;
        this.fuenteDinamicaData[name] = firstName;
      } else {
        this.selectedFuenteDinamica[name] = lastName;
        this.fuenteDinamicaData[name] = lastName;
      }
    }

    if (name === 'razon_social' && isCompany) {
      this.selectedFuenteDinamica[name] = data?.['razonSocial'];
      this.fuenteDinamicaData[name] = data?.['razonSocial'];
    }

    if (name === 'tipo_documento') {

      let typeDocument = "";

      if (isConsumer) {
        const labelDropDown = this.localStorageService.getBuscadorSelect?.labelDropDown || '';
        typeDocument = labelDropDown.toLocaleLowerCase() === 'persona física' ? 'CI' : 'OT';
      } else {
        typeDocument = 'RUT';
      }

      this.selectedFuenteDinamica[name] = typeDocument;
      this.fuenteDinamicaData[name] = typeDocument;
    }
  }

}
